import * as XLSX from "xlsx";
import "./TimeTrackerOverview.css";
import Modal from "react-modal";
import { toast } from "react-toastify";
import isEqual from "lodash/isEqual";
import { useReactToPrint } from "react-to-print";
import TimeTable from "./TimeTrackerOverviewTable.jsx";
import { useSelector, useDispatch } from "react-redux";
import OverviewTotal from "./TimeTrackerOverviewTotal.jsx";
import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import ReactDOM from "react-dom";
import { useQueryClient } from "react-query";
import userTypeConsts from "../../../constants/userTypeConsts.js";
import TimeTrackerOverviewGraph from "./TimeTrackerOverviewGraph.jsx";
import TrackerOverviewPieChart from "./TimeTrackerOverviewPiechart.jsx";
import TimeTrackerOverviewPrintTable from "./TimeTrackerOverviewPrintTable.jsx";
import TruncateFilterFieldView from "../../helpers/truncateFilterFieldView.js";
import Calendar from "../../../helpers/dateComponents/Calendar.jsx";
import { motion } from 'framer-motion';
import {
  useGetAllClients,
  useGetAllArchivedProjects,
  useGetClients,
  useGetDepartments,
  useGetProjects,
  useGetSprints,
  useGetTags,
  useGetTeams,
  useGetTimerData,
} from "./useTimeTracker.jsx";
import {
  setTeam,
  setProject,
  setClient,
  setTag,
  setSprint,
  setDepartment,
  setPerPage,
  setTask,
  setAllFilters,
} from "../../../features/timeTracker/timeTrackerSlice.js";
import moment from "moment-timezone";
import TimestampConverter from "../Timer/tracker/helpers/TimestampConverter.jsx";
import { getEntryDayKey, formatEntryDay, getEntryZone } from "../../../utils/tenantDate";

const DownloadIcon = () => <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.52625 15.8539C6.55157 15.8771 6.57923 15.8979 6.60884 15.9161L6.65014 15.9361L6.70235 15.9621L6.75689 15.9782L6.80482 15.9904C6.87651 16.0043 6.95092 16.0043 7.023 15.9904L7.07092 15.9782L7.12547 15.9621L7.17767 15.9361L7.21897 15.9161C7.24897 15.8979 7.27664 15.8771 7.30196 15.8539L12.6977 10.9C12.8773 10.7014 12.8625 10.41 12.6634 10.2275C12.4643 10.045 12.1464 10.0314 11.9298 10.1961L7.45702 14.3V1.5C7.45702 1.22393 7.21274 1 6.91157 1C6.6104 1 6.36612 1.22393 6.36612 1.5V14.3L1.89339 10.1961C1.67677 10.0314 1.35884 10.045 1.15975 10.2275C0.960661 10.41 0.945856 10.7014 1.12547 10.9L6.52547 15.8539H6.52625Z" fill="white" stroke="white" strokeWidth="0.5"/></svg>;
const PrintIcon = () => <svg width="18" height="16" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.4255 6.37198H19.383V1.48836C19.383 1.35886 19.3292 1.23459 19.2334 1.14302C19.1377 1.05145 19.0077 1 18.8723 1H7.38298C7.10076 1 6.87234 1.21889 6.87234 1.48836V6.37198H4.57447C3.6266 6.37198 2.71748 6.73215 2.04681 7.37312C1.37614 8.0141 1 8.88399 1 9.79052V14.9183C1 15.8248 1.3766 16.6943 2.04681 17.3357C2.71702 17.9767 3.6266 18.3369 4.57447 18.3369H6.87234V21.5112C6.87234 21.6407 6.92614 21.765 7.02188 21.8565C7.11763 21.9481 7.24757 21.9996 7.38298 21.9996H18.8723C19.0077 21.9996 19.1377 21.9481 19.2334 21.8565C19.3292 21.765 19.383 21.6407 19.383 21.5112V18.3369H21.4255C22.3734 18.3369 23.2825 17.9767 23.9532 17.3357C24.6234 16.6947 25 15.8253 25 14.9183V9.79052C25 8.88399 24.6234 8.01453 23.9532 7.37312C23.283 6.73171 22.3734 6.37198 21.4255 6.37198ZM7.89362 1.97672H18.3617V6.37198H7.89362V1.97672ZM18.3617 17.8485V21.0228H7.89362V14.6741H18.3617V17.8485ZM23.9787 14.9183C23.9787 15.5663 23.7097 16.1872 23.231 16.645C22.7523 17.1029 22.1026 17.3601 21.4255 17.3601H19.383V14.1858C19.383 14.0563 19.3292 13.932 19.2334 13.8404C19.1377 13.7489 19.0077 13.6974 18.8723 13.6974H7.38298C7.10076 13.6974 6.87234 13.9163 6.87234 14.1858V17.3601H4.57447C3.89742 17.3601 3.24818 17.1029 2.769 16.645C2.29027 16.1872 2.02128 15.5663 2.02128 14.9183V9.79052C2.02128 9.143 2.29027 8.52165 2.769 8.06381C3.24772 7.60597 3.89742 7.34871 4.57447 7.34871H21.4255C22.1026 7.34871 22.7518 7.60597 23.231 8.06381C23.7097 8.52165 23.9787 9.143 23.9787 9.79052V14.9183Z" fill="white" stroke="white" strokeWidth="0.2"/><path d="M9.17031 17.36H16.8299C17.1121 17.36 17.3405 17.1416 17.3405 16.8717C17.3405 16.6018 17.1121 16.3833 16.8299 16.3833H9.17031C8.88809 16.3833 8.65967 16.6022 8.65967 16.8717C8.65967 17.1411 8.88809 17.36 9.17031 17.36Z" fill="white"/><path d="M9.17031 19.5578H16.8299C17.1121 19.5578 17.3405 19.3389 17.3405 19.0694C17.3405 18.7999 17.1121 18.5811 16.8299 18.5811H9.17031C8.88809 18.5811 8.65967 18.7999 8.65967 19.0694C8.65967 19.3389 8.88809 19.5578 9.17031 19.5578Z" fill="white"/></svg>;

const TimeTrackerOverview = () => {
  const dispatch = useDispatch();
  const [dates, setDates] = useState(new Date());

  const convertToStartOfDay = (dateString, timeZone) => {
    return moment.tz(dateString, "YYYY-MM-DD", timeZone).startOf("day").toDate();
  };

  const timezone = global.config.getTimeZone();

  // The picker names CALENDAR DAYS and renders them in the browser's zone, so
  // its defaults are built from the browser's calendar — the same basis the
  // library's own Today / Yesterday / This Month presets use. Deriving them
  // from a tenant-zone instant made the picker highlight the wrong days
  // (Sep 30 instead of Oct 1, and tomorrow instead of today) for anyone whose
  // zone differs from the tenant's.
  //
  // This does not change WHICH data a range covers: the chosen day names are
  // still resolved into tenant-zone boundaries server-side.
  const browserToday = new Date();
  const firstDayOfMonth = new Date(browserToday.getFullYear(), browserToday.getMonth(), 1);
  const startOfDay = new Date(browserToday.getFullYear(), browserToday.getMonth(), browserToday.getDate());

  const [showCalendar, setShowCalendar] = useState(false);
  const [showModalCalendar, setShowModalCalendar] = useState(false);
  const [dateRange, setDateRange] = useState([firstDayOfMonth, startOfDay]);
  const [perPage, setPerPages] = useState(10);
  const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
  const tracker = useSelector((state) => state.tracker);
  const timerData = useSelector((state) => state.timerData.timerDataState);
  const [selClient, setSelClient] = useState(null);
  const componentRef = useRef();
  const printComponentRef = useRef();
  const isUpdatingClientRef = useRef(false);
  const isInitialLoad = useRef(0);
  const prevProjectsRef = useRef(null);
  const prevTagsRef = useRef(null);
  const prevSprintsRef = useRef(null);
  const prevClientsRef = useRef(null);
  const prevDepartmentsRef = useRef(null);
  const prevTeamsRef = useRef(null);
  const prevUserRef = useRef(null);

  const [taskName, setTaskName] = useState('');
  const [selectAllTeam, setSelectAllTeam] = useState(true);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [isTeamDropdownOpen, setIsTeamDropdownOpen] = useState(false);
  const [isTeamModalDropdownOpen, setIsTeamModalDropdownOpen] = useState(false);
  const [isUserStatusDropdownOpen, setIsUserStatusDropdownOpen] = useState(false);
  const [isUserStatusModalDropdownOpen, setIsUserStatusModalDropdownOpen] = useState(false);
  const [userStatusFilter, setUserStatusFilter] = useState("Active");
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [selectAllClient, setSelectAllClient] = useState(true);
  const [selectedClients, setSelectedClients] = useState([]);
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const [isClientModalDropdownOpen, setIsClientModalDropdownOpen] = useState(false);
  const [clientStatusFilter, setClientStatusFilter] = useState("Active"); // Default to "Active"
  const [isClientStatusDropdownOpen, setIsClientStatusDropdownOpen] = useState(false);
  const [isClientStatusModalDropdownOpen, setIsClientStatusModalDropdownOpen] = useState(false);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [selectAllProject, setSelectAllProject] = useState(true);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [sortedProjects, setSortedProjects] = useState([]);
  const [isProjectDropdownOpen, setIsProjectDropdownOpen] = useState(false);
  const [isProjectModalDropdownOpen, setIsProjectModalDropdownOpen] = useState(false);
  const [isProjectStatusDropdownOpen, setIsProjectStatusDropdownOpen] = useState(false);
  const [isProjectStatusModalDropdownOpen, setIsProjectStatusModalDropdownOpen] = useState(false);
  const [projectStatusFilter, setProjectStatusFilter] = useState("All");
  const [projectSearchTerm, setProjectSearchTerm] = useState('');
  const [selectAllDept, setSelectAllDept] = useState(true);
  const [selectedDepts, setSelectedDepts] = useState([]);
  const [isDeptDropdownOpen, setIsDeptDropdownOpen] = useState(false);
  const [isDeptModalDropdownOpen, setIsDeptModalDropdownOpen] = useState(false);
  const [deptSearchTerm, setDeptSearchTerm] = useState('');
  const [selectAllTag, setSelectAllTag] = useState(true);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isTagDropdownOpen, setIsTagDropdownOpen] = useState(false);
  const [isTagModalDropdownOpen, setIsTagModalDropdownOpen] = useState(false);
  const [tagSearchTerm, setTagSearchTerm] = useState('');
  const [selectAllSprint, setSelectAllSprint] = useState(true);
  const [selectedSprints, setSelectedSprints] = useState([]);
  const [sortedSprints, setSortedSprints] = useState([]);
  const [isSprintDropdownOpen, setIsSprintDropdownOpen] = useState(false);
  const [isSprintModalDropdownOpen, setIsSprintModalDropdownOpen] = useState(false);
  const [sprintSearchTerm, setSprintSearchTerm] = useState('');
  const teamDropdownRef = useRef(null);
  const teamModalDropdownRef = useRef(null);
  const userStatusDropdownRef = useRef(null);
  const userStatusModalDropdownRef = useRef(null);
  const projectDropdownRef = useRef(null);
  const projectModalDropdownRef = useRef(null);
  const projectStatusDropdownRef = useRef(null);
  const projectStatusModalDropdownRef = useRef(null);
  const clientDropdownRef = useRef(null);
  const clientModalDropdownRef = useRef(null);
  const clientStatusDropdownRef = useRef(null);
  const clientStatusModalDropdownRef = useRef(null);
  const clientStatusListRef = useRef(null);
  const deptDropdownRef = useRef(null);
  const deptModalDropdownRef = useRef(null);
  const tagDropdownRef = useRef(null);
  const tagModalDropdownRef = useRef(null);
  const sprintDropdownRef = useRef(null);
  const sprintModalDropdownRef = useRef(null);
  const showingDropdownRef = useRef(null);
  const calendarRef = useRef(null);
  const calendarModalRef = useRef(null);
  const calendarModalPortalRef = useRef(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { appSettings } = useSelector((state) => state.appSettings);
  const token = useSelector((state) => state.auth.token);

  const { data: teams = [], isLoading: teamLoading, isError: teamError, } = useGetTeams(token);
  const { data: clients = [], isLoading: clientLoading, isError: clientError, } = useGetAllClients(token);
  const { data: projects = [], isLoading: projectLoading, isError: projectError, } = useGetAllArchivedProjects(token);
  const { data: departments = [], isLoading: departmentLoading, isError: departmentError, } = useGetDepartments(token);
  const { data: tags = [], isLoading: tagsLoading, isError: tagsError, } = useGetTags(token);
  const { data: sprints = [], isLoading: sprintsLoading, isError: sprintsError, } = useGetSprints(token);
  const { data: timerDatas = [], isLoading: timerLoadingRaw, refetch: refetchAll } = useGetTimerData(
    token,
    tracker,
    dateRange ? dateRange[0] : null,
    dateRange ? dateRange[1] : null,
  );
  const timerLoading = timerLoadingRaw || !tracker.team || (Array.isArray(tracker.team) && tracker.team.length === 0);

  useEffect(() => {
    if (!tracker.team || (Array.isArray(tracker.team) && tracker.team.length === 0)) return;
    const fetchWithDebounce = setTimeout(async () => {
      try {
        await refetchAll();
      } catch (error) {
        console.error("Error fetching timer data:", error);
      }
    }, 300);

    return () => clearTimeout(fetchWithDebounce);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tracker.team, dateRange, refetchAll]);

  const handleTaskNameChange = async (e) => {
    const value = e.target.value;
    setTaskName(value);

    try {
      await dispatch(setTask(value));
    } catch (error) {
      console.error("Failed to update task name:", error);
      // Optional: show a toast or alert
      // toast.error("Unable to update task. Please try again.");
    }
  };

  const filteredUsers = useMemo(() => Array.isArray(teams)
    ? teams.filter((user) => {
      try {
        const fullName = user?.first_name
          ? `${user.first_name} ${user.middle_name || ''} ${user.last_name || ''}`.trim()
          : user?.company_first_name
            ? `${user.company_first_name} ${user.company_last_name || ''}`.trim()
            : user?.company_name || '';

        return fullName.toLowerCase().includes(userSearchTerm?.toLowerCase() || '');
      } catch (error) {
        console.error("Error filtering user:", error, user);
        return false;
      }
    })
    : [], [teams, userSearchTerm]);

  const handleUserSearchChange = (e) => {
    setUserSearchTerm(e.target.value);
  };

  const toggleUserStatusDropdown = () => {
    setIsUserStatusDropdownOpen(!isUserStatusDropdownOpen);
  };

  const toggleUserStatusModalDropdown = () => {
    setIsUserStatusModalDropdownOpen(!isUserStatusModalDropdownOpen);
  };

  const handleUserStatusChange = (status) => {
    try {
      setUserStatusFilter(status);

      if (!Array.isArray(teams)) {
        console.warn("Teams is not a valid array:", teams);
        setSelectedTeams([]);
        setSelectAllTeam(false);
        return;
      }

      const filteredTeamIds = teams
        .filter((team) => {
          if (status === "All") return true;
          if (status === "Active") return team.is_active === true;
          return team.is_active === false;
        })
        .map((team) => team._id);

      const updatedSelectedTeams = Array.isArray(selectedTeams)
        ? selectedTeams.filter((teamId) => filteredTeamIds.includes(teamId))
        : [];

      setSelectedTeams(updatedSelectedTeams);
      setSelectAllTeam(false);
    } catch (error) {
      console.error("Error changing user status filter:", error);
      setSelectedTeams([]);
      setSelectAllTeam(false);
    }
  };


  const handleCheckboxTeamChange = (teamId) => {
    try {
      if (!teamId) {
        console.warn("Invalid teamId provided:", teamId);
        return;
      }

      if (!Array.isArray(selectedTeams)) {
        console.error("selectedTeams is not an array:", selectedTeams);
        setSelectedTeams([teamId]);
        return;
      }

      const updatedSelection = [...selectedTeams];
      const index = updatedSelection.indexOf(teamId);

      if (index === -1) {
        updatedSelection.push(teamId); // Add to selection
      } else {
        updatedSelection.splice(index, 1); // Remove from selection
      }

      setSelectedTeams(updatedSelection);
    } catch (error) {
      console.error("Error updating selected teams:", error);
    }
  };

  const handleSelectAllTeamChange = () => {
    try {
      if (!Array.isArray(teams)) {
        console.error("Invalid teams data:", teams);
        return;
      }

      const filteredTeamIds = teams
        .filter((team) => {
          if (userStatusFilter === "All") return true;
          if (userStatusFilter === "Active") return team?.is_active === true;
          return team?.is_active === false;
        })
        .map((team) => team?._id)
        .filter(Boolean); // Ensure no undefined/null IDs

      if (!selectAllTeam) {
        setSelectedTeams(filteredTeamIds);
      } else {
        setSelectedTeams([]);
      }

      setSelectAllTeam((prev) => !prev);
    } catch (error) {
      console.error("Error handling select all teams:", error);
    }
  };

  useEffect(() => {
    if (isInitialLoad.current > 0) return;
    try {
      if (!Array.isArray(teams)) {
        console.error("Invalid 'teams' data:", teams);
        return;
      }

      const filteredTeamIds = teams
        .filter((team) => {
          if (userStatusFilter === "All") return true;
          if (userStatusFilter === "Active") return team?.is_active === true;
          return team?.is_active === false;
        })
        .map((team) => team?._id)
        .filter(Boolean);

      const allSelected = filteredTeamIds.length > 0 && selectedTeams.length === filteredTeamIds.length;

      setSelectAllTeam(allSelected);

      if (allSelected) {
        selectTeam(filteredTeamIds);
      } else {
        selectTeam(Array.isArray(selectedTeams) ? selectedTeams : []);
      }
    } catch (error) {
      console.error("Error in useEffect for syncing team selection:", error);
    }
  }, [selectedTeams, teams]);

  const toggleTeamDropdown = () => {
    if (teamLoading) return;
    setIsTeamDropdownOpen(!isTeamDropdownOpen);
    setUserSearchTerm('');
  };

  const toggleTeamModalDropdown = () => {
    if (teamLoading) return;
    setIsTeamModalDropdownOpen(!isTeamModalDropdownOpen);
    setUserSearchTerm('');
  };

  const filteredClients = useMemo(() => clients && Array.isArray(clients)
    ? clients
      .filter((client) =>
        client && client?.client_name?.toLowerCase().includes(clientSearchTerm && clientSearchTerm?.toLowerCase())
      )
      .sort((a, b) =>
        a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
      )
    : [], [clients, clientSearchTerm]);

  const handleClientSearchChange = (e) => {
    setClientSearchTerm(e.target.value);
  };

  const handleCheckboxClientChange = (clientId) => {
    try {
      const updatedSelection = [...selectedClients];
      const index = updatedSelection.indexOf(clientId);

      // Add or remove client from selection
      if (index === -1) {
        updatedSelection.push(clientId);
      } else {
        updatedSelection.splice(index, 1);
      }

      let filteredProjects = [];
      if (Array.isArray(projects)) {
        filteredProjects = projects.filter((project) => {
          const clientId = project?.client_name?._id;
          const isSelected = updatedSelection.includes(clientId);
          const isStatusMatch =
            projectStatusFilter === "All" ||
            (projectStatusFilter === "Active"
              ? project?.is_active === true && project?.is_archived === false
              : projectStatusFilter === "Inactive"
                ? project?.is_active === false && project?.is_archived === false
                : project?.is_archived === true);
          return isSelected && isStatusMatch;
        });
      } else {
        console.warn("Projects list is not an array:", projects);
      }

      const filteredProjectIds = Array.isArray(filteredProjects)
        ? filteredProjects.map((project) => project?._id).filter(Boolean)
        : [];

      let filteredSprints = [];
      if (Array.isArray(sprints)) {
        filteredSprints = sprints.filter((sprint) => {
          const projectId = sprint?.project?._id;
          return filteredProjectIds.includes(projectId);
        });
      } else {
        console.warn("Sprints list is not an array:", sprints);
      }

      setSelectedProjects(filteredProjectIds);
      setSortedProjects(filteredProjects);
      selectProject(filteredProjectIds);
      setSelectedSprints(filteredSprints.map((sprint) => sprint?._id).filter(Boolean));
      setSortedSprints(filteredSprints);
      setSelectedClients(updatedSelection);

    } catch (error) {
      console.error("Error in handleCheckboxClientChange:", error);
    }
  };

  const handleSelectAllClientChange = () => {
    try {
      if (!selectAllClient) {
        const allClientIds = Array.isArray(clients)
          ? clients
            .filter((client) =>
              clientStatusFilter === "All"
                ? true
                : clientStatusFilter === "Active"
                  ? client.is_active === true
                  : client.is_active === false
            )
            .map(client => client?._id)
            .filter(Boolean)
          : [];

        setSelectedClients(allClientIds);

        let filteredProjects = [];
        if (Array.isArray(projects)) {
          filteredProjects = projects.filter(project => {
            const clientId = project?.client_name?._id;
            const isClientMatched = allClientIds.includes(clientId);
            const statusMatches =
              projectStatusFilter === "All" ||
              (projectStatusFilter === "Active"
                ? project?.is_active === true && project?.is_archived === false
                : projectStatusFilter === "Inactive"
                  ? project?.is_active === false && project?.is_archived === false
                  : project?.is_archived === true);
            return isClientMatched && statusMatches;
          });
        } else {
          console.warn("Projects list is not an array:", projects);
        }

        const filteredProjectIds = filteredProjects.map(p => p?._id).filter(Boolean);

        let filteredSprints = [];
        if (Array.isArray(sprints)) {
          filteredSprints = sprints.filter(sprint =>
            filteredProjectIds.includes(sprint?.project?._id)
          );
        } else {
          console.warn("Sprints list is not an array:", sprints);
        }

        setSelectedProjects(filteredProjectIds);
        setSortedProjects(filteredProjects);
        selectProject(filteredProjectIds);
        setSelectedSprints(filteredSprints.map(s => s?._id).filter(Boolean));
        setSortedSprints(filteredSprints);

      } else {
        // Reset everything if deselecting all
        setSelectedClients([]);
        setSelectedProjects([]);
        setSortedProjects([]);
        setSelectedSprints([]);
        setSortedSprints([]);
      }

      setSelectAllClient(prev => !prev);

    } catch (error) {
      console.error("Error in handleSelectAllClientChange:", error);
    }
  };

  const selectClient = useCallback(async (client) => {
    setSelClient(client);
    await dispatch(setClient(client));
  }, [dispatch]);

  useEffect(() => {
    if (isInitialLoad.current > 0) return;
    // Prevent infinite loop by checking if we're already updating
    if (isUpdatingClientRef.current) {
      return;
    }

    try {
      const validClients = Array.isArray(clients)
        ? clients.filter((client) =>
          clientStatusFilter === "All"
            ? true
            : clientStatusFilter === "Active"
              ? client.is_active === true
              : client.is_active === false
        )
        : [];
      const validSelectedClients = Array.isArray(selectedClients) ? selectedClients : [];

      const allSelected = validClients.length > 0 && validSelectedClients.length === validClients.length;

      setSelectAllClient(allSelected);

      // Only call selectClient if the selection actually changed
      const currentClient = selClient;
      let shouldUpdate = false;
      
      if (allSelected) {
        // If all should be selected, update only if current is not null
        shouldUpdate = currentClient !== null;
      } else {
        // Normalize to arrays for comparison
        const currentArray = Array.isArray(currentClient) 
          ? currentClient 
          : (currentClient !== null && currentClient !== undefined ? [currentClient] : []);
        shouldUpdate = !isEqual(currentArray, validSelectedClients);
      }

      if (shouldUpdate) {
        isUpdatingClientRef.current = true;
        if (allSelected) {
          selectClient(null).finally(() => {
            isUpdatingClientRef.current = false;
          });
        } else {
          selectClient(validSelectedClients).finally(() => {
            isUpdatingClientRef.current = false;
          });
        }
      }
    } catch (error) {
      console.error("Error in selectAllClient useEffect:", error);
      setSelectAllClient(false);
      isUpdatingClientRef.current = true;
      selectClient([]).finally(() => {
        isUpdatingClientRef.current = false;
      });
    }
  }, [selectedClients, clients, clientStatusFilter, selectClient, selClient]);

  const toggleClientDropdown = () => {
    setIsClientDropdownOpen(!isClientDropdownOpen);
    setClientSearchTerm('');
  };

  const toggleClientModalDropdown = () => {
    if (clientLoading) return;
    setIsClientModalDropdownOpen(!isClientModalDropdownOpen);
    setClientSearchTerm('');
  };

  const toggleClientStatusDropdown = () => {
    setIsClientStatusDropdownOpen((prev) => !prev);
  };

  const toggleClientStatusModalDropdown = () => {
    setIsClientStatusModalDropdownOpen((prev) => !prev);
  };

  const handleClientStatusChange = (status) => {
    try {
      setClientStatusFilter(status);
      setIsClientStatusDropdownOpen(false);

      if (!Array.isArray(clients)) {
        console.warn("Clients is not a valid array:", clients);
        setSelectedClients([]);
        setSelectAllClient(false);
        setSelectedProjects([]);
        setSortedProjects([]);
        setSelectedSprints([]);
        setSortedSprints([]);
        return;
      }

      const filteredClientIds = clients
        .filter((client) => {
          if (status === "All") return true;
          if (status === "Active") return client.is_active === true;
          return client.is_active === false;
        })
        .map((client) => client._id)
        .filter(Boolean);

      const updatedSelectedClients = Array.isArray(selectedClients)
        ? selectedClients.filter((clientId) => filteredClientIds.includes(clientId))
        : [];

      let filteredProjects = [];
      if (Array.isArray(projects)) {
        filteredProjects = projects.filter((project) => {
          const clientId = project?.client_name?._id;
          const isSelected = updatedSelectedClients.includes(clientId);
          const isStatusMatch =
            projectStatusFilter === "All" ||
            (projectStatusFilter === "Active"
              ? project?.is_active === true && project?.is_archived === false
              : projectStatusFilter === "Inactive"
                ? project?.is_active === false && project?.is_archived === false
                : project?.is_archived === true);
          return isSelected && isStatusMatch;
        });
      } else {
        console.warn("Projects list is not an array:", projects);
      }

      const filteredProjectIds = Array.isArray(filteredProjects)
        ? filteredProjects.map((project) => project?._id).filter(Boolean)
        : [];

      let filteredSprints = [];
      if (Array.isArray(sprints)) {
        filteredSprints = sprints.filter((sprint) => {
          const projectId = sprint?.project?._id;
          return filteredProjectIds.includes(projectId);
        });
      } else {
        console.warn("Sprints list is not an array:", sprints);
      }

      setSelectedClients(updatedSelectedClients);
      setSelectAllClient(false);
      setSelectedProjects(filteredProjectIds);
      setSortedProjects(filteredProjects);
      selectProject(filteredProjectIds);
      setSelectedSprints(filteredSprints.map((sprint) => sprint?._id).filter(Boolean));
      setSortedSprints(filteredSprints);
    } catch (error) {
      console.error("Error handling client status change:", error);
      setSelectedClients([]);
      setSelectAllClient(false);
      setSelectedProjects([]);
      setSortedProjects([]);
      setSelectedSprints([]);
      setSortedSprints([]);
    }
  };

  const filteredDropdownProjects = useMemo(() => sortedProjects
    ? sortedProjects.filter((project) =>
        project && project.project_name?.toLowerCase().includes(projectSearchTerm?.toLowerCase())
      ).sort((a, b) =>
        a.project_name?.toLowerCase().localeCompare(b.project_name?.toLowerCase())
      )
    : [], [sortedProjects, projectSearchTerm]);

  const handleProjectSearchChange = (e) => {
    setProjectSearchTerm(e.target.value);
  };

  const toggleProjectStatusDropdown = () => {
    setIsProjectStatusDropdownOpen(!isProjectStatusDropdownOpen);
  };

  const toggleProjectStatusModalDropdown = () => {
    setIsProjectStatusModalDropdownOpen(!isProjectStatusModalDropdownOpen);
  };

  const handleProjectStatusChange = (status) => {
    try {
      setProjectStatusFilter(status);

      const validSortedProjects = Array.isArray(projects) ? projects : [];
      const validSelectedProjects = Array.isArray(selectedProjects) ? selectedProjects : [];

      const filteredProjectIds = validSortedProjects
        .filter((project) => {
          if (status === "All") return true;
          if (status === "Active") return project.is_active === true && project.is_archived === false;
          if (status === "Inactive") return project.is_active === false && project.is_archived === false;
          return project.is_archived === true;
        })
        .map((project) => project._id)
        .filter(Boolean);

      const updatedSelectedProjects = validSelectedProjects.filter((projectId) =>
        filteredProjectIds.includes(projectId)
      );

      const selectedClientIds = [
        ...new Set(
          validSortedProjects
            .filter((project) => filteredProjectIds.includes(project?._id))
            .map((project) => project?.client_name?._id)
            .filter(Boolean)
        ),
      ];

      let filteredSprints = [];
      if (Array.isArray(sprints)) {
        filteredSprints = sprints.filter((sprint) => {
          const projectId = sprint?.project?._id;
          return filteredProjectIds.includes(projectId);
        });
      } else {
        console.warn("Sprints list is not an array:", sprints);
      }

      const allClientIdsForProjects = [
        ...new Set(
          validSortedProjects
            .filter((project) =>
              status === "All"
                ? true
                : status === "Active"
                  ? project.is_active === true && project.is_archived === false
                  : status === "Inactive"
                    ? project.is_active === false && project.is_archived === false
                    : project.is_archived === true
            )
            .map((project) => project?.client_name?._id)
            .filter(Boolean)
        ),
      ];
      const allClientsSelected =
        allClientIdsForProjects.length > 0 &&
        selectedClientIds.length === allClientIdsForProjects.length;

      setSelectedProjects(updatedSelectedProjects);
      setSortedProjects(
        validSortedProjects.filter((project) =>
          filteredProjectIds.includes(project._id)
        )
      );
      setSelectedSprints(filteredSprints.map((sprint) => sprint?._id).filter(Boolean));
      setSortedSprints(filteredSprints);
      setSelectAllProject(false);
      // setSelectedClients(selectedClientIds);
      // setSelectAllClient(allClientsSelected);
    } catch (error) {
      console.error("Error handling project status change:", error);
      setSelectedProjects([]);
      setSortedProjects([]);
      setSelectedSprints([]);
      setSortedSprints([]);
      setSelectAllProject(false);
      setSelectedClients([]);
      setSelectAllClient(false);
    }
  };

  const handleCheckboxProjectChange = (projectId) => {
    try {
      const updatedSelection = Array.isArray(selectedProjects) ? [...selectedProjects] : [];
      const index = updatedSelection.indexOf(projectId);

      if (index === -1) {
        updatedSelection.push(projectId);
      } else {
        updatedSelection.splice(index, 1);
      }

      setSelectedProjects(updatedSelection);

      // Defensive: ensure sortedProjects is an array
      const validSortedProjects = Array.isArray(sortedProjects) ? sortedProjects : [];
      const selectedClientIds = [
        ...new Set(
          validSortedProjects
            .filter((project) => updatedSelection.includes(project?._id))
            .map((project) => project?.client_name?._id)
            .filter(Boolean)
        ),
      ];
      setSelectedClients(selectedClientIds);

      // Defensive: ensure sprints is an array
      const validSprints = Array.isArray(sprints) ? sprints : [];
      const filteredSprints = validSprints.filter((sprint) =>
        updatedSelection.includes(sprint?.project?._id)
      );

      setSelectedSprints(filteredSprints.map((sprint) => sprint?._id).filter(Boolean));
      setSortedSprints(filteredSprints);

    } catch (error) {
      console.error("Error in handleCheckboxProjectChange:", error);
      // Optional fallback if needed
      setSelectedProjects([]);
      setSelectedClients([]);
      setSelectedSprints([]);
      setSortedSprints([]);
    }
  };

  const handleSelectAllProjectChange = () => {
    try {
      const isProjectMatchingStatus = (project) =>
        projectStatusFilter === "All" ||
        (projectStatusFilter === "Active"
          ? project?.is_active === true && project?.is_archived === false
          : projectStatusFilter === "Inactive"
            ? project?.is_active === false && project?.is_archived === false
            : project?.is_archived === true);

      const validSortedProjects = Array.isArray(sortedProjects) ? sortedProjects : [];
      const validSprints = Array.isArray(sprints) ? sprints : [];

      const filteredProjects = validSortedProjects.filter(isProjectMatchingStatus);
      const filteredProjectIds = filteredProjects.map((project) => project?._id).filter(Boolean);
      const allClientIds = [
        ...new Set(
          filteredProjects
            .map((project) => project?.client_name?._id)
            .filter(Boolean)
        )
      ];

      const filteredSprints = validSprints.filter((sprint) =>
        filteredProjectIds.includes(sprint?.project?._id)
      );

      if (!selectAllProject) {
        setSelectedProjects(filteredProjectIds);
        setSortedProjects(filteredProjects);
        setSelectedSprints(filteredSprints.map((sprint) => sprint?._id).filter(Boolean));
        setSortedSprints(filteredSprints);
        setSelectedClients(allClientIds);
        setSelectAllClient(
          allClientIds.length > 0 &&
          allClientIds.every((clientId) =>
            Array.isArray(selectedClients) ? selectedClients.includes(clientId) : false
          )
        );
      } else {
        setSelectedProjects([]);
        // setSortedProjects([]);
        // setSelectedClients([]);
        setSelectedSprints([]);
        setSortedSprints([]);
      }

      setSelectAllProject(prev => !prev);
    } catch (error) {
      console.error("Error in handleSelectAllProjectChange:", error);
      setSelectedProjects([]);
      setSelectedClients([]);
      setSelectedSprints([]);
      setSortedSprints([]);
      setSelectAllProject(false);
    }
  };

  // Use refs to track previous values and prevent infinite loops
  const previousSelectedProjectsRef = useRef(null);
  const previousFilteredProjectIdsRef = useRef(null);
  
  useEffect(() => {
    if (isInitialLoad.current > 0) return;
    const fetchAndSetSelections = async () => {
      try {
        const validSortedProjects = Array.isArray(sortedProjects) ? sortedProjects : [];
        const validSelectedProjects = Array.isArray(selectedProjects) ? selectedProjects : [];

        const filteredProjectIds = validSortedProjects
          .filter((project) =>
            projectStatusFilter === "All"
              ? true
              : projectStatusFilter === "Active"
                ? project?.is_active === true && project?.is_archived === false
                : projectStatusFilter === "Inactive"
                  ? project?.is_active === false && project?.is_archived === false
                  : project?.is_archived === true
          )
          .map((project) => project?._id)
          .filter(Boolean);

        const allSelected =
          filteredProjectIds.length > 0 &&
          validSelectedProjects.length === filteredProjectIds.length;

        setSelectAllProject(allSelected);

        // Compare arrays to check if values have actually changed (avoid expensive JSON.stringify)
        const arraysEqual = (a, b) => {
          if (!a || !b) return a === b;
          if (a.length !== b.length) return false;
          return a.every((val, idx) => val === b[idx]);
        };

        const selectedProjectsChanged = !arraysEqual(previousSelectedProjectsRef.current, validSelectedProjects);
        const filteredIdsChanged = !arraysEqual(previousFilteredProjectIdsRef.current, filteredProjectIds);
        
        // Only update Redux if values have actually changed to prevent infinite loops
        if (selectedProjectsChanged || filteredIdsChanged) {
          // Store copies to avoid reference issues
          previousSelectedProjectsRef.current = [...validSelectedProjects];
          previousFilteredProjectIdsRef.current = [...filteredProjectIds];
          
          const projectIdsToSet = allSelected ? filteredProjectIds : validSelectedProjects;
          selectProject(projectIdsToSet);
        }
      } catch (error) {
        console.error("Error during selection sync in useEffect:", error);
        setSelectAllProject(false);
        // Only reset if not already empty
        if (previousSelectedProjectsRef.current?.length > 0) {
          previousSelectedProjectsRef.current = [];
          selectProject([]);
        }
      }
    };

    fetchAndSetSelections();
  }, [selectedProjects, projects, projectStatusFilter, sortedProjects]);

  const toggleProjectDropdown = () => {
    if (projectLoading) return;
    setIsProjectDropdownOpen(!isProjectDropdownOpen);
    setProjectSearchTerm('');
  };

  const toggleProjectModalDropdown = () => {
    if (projectLoading) return;
    setIsProjectModalDropdownOpen(!isProjectModalDropdownOpen);
    setProjectSearchTerm('');
  };

  const filteredDepts = useMemo(() => departments
    ? departments.filter((dept) =>
        dept && dept.user_department?.toLowerCase().includes(deptSearchTerm && deptSearchTerm?.toLowerCase())
      ).sort((a, b) =>
        a.user_department?.toLowerCase().localeCompare(b.user_department?.toLowerCase())
      )
    : [], [departments, deptSearchTerm]);

  const handleDeptSearchChange = (e) => {
    setDeptSearchTerm(e.target.value);
  };

  const handleCheckboxDeptChange = (deptId) => {
    try {
      if (!deptId) throw new Error("Invalid department ID");

      const currentSelection = Array.isArray(selectedDepts) ? [...selectedDepts] : [];
      const index = currentSelection.indexOf(deptId);

      if (index === -1) {
        currentSelection.push(deptId);
      } else {
        currentSelection.splice(index, 1);
      }

      setSelectedDepts(currentSelection);
    } catch (error) {
      console.error("Error in handleCheckboxDeptChange:", error);
      // Optionally reset state or notify user
      setSelectedDepts([]);
    }
  };

  const handleSelectAllDeptChange = () => {
    try {
      const validDepartments = Array.isArray(departments) ? departments : [];

      if (!selectAllDept) {
        const allDeptIds = validDepartments.map((dept) => dept?._id).filter(Boolean);
        setSelectedDepts(allDeptIds);
      } else {
        setSelectedDepts([]);
      }

      setSelectAllDept((prev) => !prev);
    } catch (error) {
      console.error("Error in handleSelectAllDeptChange:", error);
      // Optional: fallback/reset in case of error
      setSelectedDepts([]);
      setSelectAllDept(false);
    }
  };

  useEffect(() => {
    if (isInitialLoad.current > 0) return;
    const updateSelection = async () => {
      try {
        // Check if all departments are selected
        const areAllDepartmentsSelected = selectedDepts.length === departments.length;

        // Update the select-all status
        setSelectAllDept(areAllDepartmentsSelected);

        // Conditionally select all or the specific departments
        if (areAllDepartmentsSelected) {
          selectDepartment(null); // Deselect all departments if they are fully selected
        } else {
          selectDepartment(selectedDepts); // Select the chosen departments
        }
      } catch (error) {
        console.error("Error during department selection:", error);
      }
    };

    // Call async function for selecting departments
    updateSelection();
  }, [selectedDepts, departments]); // Re-run when selectedDepts or departments change


  const toggleDeptDropdown = () => {
    if (departmentLoading) return;
    setIsDeptDropdownOpen(!isDeptDropdownOpen);
    setDeptSearchTerm('');
  };

  const toggleDeptModalDropdown = () => {
    if (departmentLoading) return;
    setIsDeptModalDropdownOpen(!isDeptModalDropdownOpen);
    setDeptSearchTerm('');
  };

  const filteredTags = useMemo(() => tags
    ? tags.filter((item) => item && item.tag_name?.toLowerCase().includes(tagSearchTerm && tagSearchTerm?.toLowerCase()))
        .sort((a, b) => a.tag_name.localeCompare(b.tag_name))
    : [], [tags, tagSearchTerm]);

  const handleTagSearchChange = (e) => {
    setTagSearchTerm(e.target.value);
  };

  const handleCheckboxTagChange = (tagId) => {
    const updatedSelection = [...selectedTags];
    const index = updatedSelection.indexOf(tagId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(tagId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedTags(updatedSelection);
  };

  const handleSelectAllTagChange = () => {
    if (!selectAllTag) {
      setSelectedTags(tags.map((tag) => tag._id));
    } else {
      setSelectedTags([]);
    }
    setSelectAllTag(!selectAllTag);
  };

  // Use refs to track previous values and prevent infinite loops
  const previousSelectedTagsRef = useRef(null);
  const previousTagsRef = useRef(null);

  useEffect(() => {
    if (isInitialLoad.current > 0) return;
    const updateTagSelection = async () => {
      try {
        const validTags = Array.isArray(tags) ? tags : [];
        const validSelectedTags = Array.isArray(selectedTags) ? selectedTags : [];

        const areAllTagsSelected = validTags.length > 0 &&
          validSelectedTags.length === validTags.length;

        setSelectAllTag(areAllTagsSelected);

        // Compare arrays to check if values have actually changed
        const arraysEqual = (a, b) => {
          if (!a || !b) return a === b;
          if (a.length !== b.length) return false;
          return a.every((val, idx) => val === b[idx]);
        };

        const selectedTagsChanged = !arraysEqual(previousSelectedTagsRef.current, validSelectedTags);
        const tagsChanged = !arraysEqual(previousTagsRef.current, validTags);

        // Only update Redux if values have actually changed to prevent infinite loops
        if (selectedTagsChanged || tagsChanged) {
          previousSelectedTagsRef.current = [...validSelectedTags];
          previousTagsRef.current = [...validTags];

          if (areAllTagsSelected) {
            selectTag(null); // Deselect all
          } else {
            selectTag(validSelectedTags); // Apply selection
          }
        }
      } catch (error) {
        console.error("Error during tag selection update:", error);
        setSelectAllTag(false);
        // Only reset if not already empty
        if (previousSelectedTagsRef.current?.length > 0) {
          previousSelectedTagsRef.current = [];
          selectTag([]); // fallback to empty selection
        }
      }
    };

    updateTagSelection();
  }, [selectedTags, tags]);

  const toggleTagDropdown = () => {
    if (tagsLoading) return;
    setIsTagDropdownOpen(!isTagDropdownOpen);
    setTagSearchTerm('');
  };

  const toggleTagModalDropdown = () => {
    if (tagsLoading) return;
    setIsTagModalDropdownOpen(!isTagModalDropdownOpen);
    setTagSearchTerm('');
  };

  const filteredSprints = useMemo(() => sortedSprints
    ? sortedSprints.filter((item) => item && item.sprint_name?.toLowerCase().includes(sprintSearchTerm && sprintSearchTerm?.toLowerCase()))
        .sort((a, b) => a.sprint_name.localeCompare(b.sprint_name))
    : [], [sortedSprints, sprintSearchTerm]);

  const handleSprintSearchChange = (e) => {
    setSprintSearchTerm(e.target.value);
  };

  const handleCheckboxSprintChange = (sprintId) => {
    try {
      if (!sprintId) throw new Error("Invalid sprint ID");

      const currentSelection = Array.isArray(selectedSprints) ? [...selectedSprints] : [];
      const index = currentSelection.indexOf(sprintId);

      if (index === -1) {
        currentSelection.push(sprintId);
      } else {
        currentSelection.splice(index, 1);
      }

      setSelectedSprints(currentSelection);

      // Derive selected project IDs from selected sprints
      const validSprints = Array.isArray(sortedSprints) ? sortedSprints : [];
      const selectedProjectIds = [
        ...new Set(
          validSprints
            .filter((sprint) => currentSelection.includes(sprint._id))
            .map((sprint) => sprint?.project?._id)
            .filter(Boolean)
        ),
      ];
      setSelectedProjects(selectedProjectIds);

      // Derive selected client IDs from selected projects
      const validProjects = Array.isArray(sortedProjects) ? sortedProjects : [];
      const selectedClientIds = [
        ...new Set(
          validProjects
            .filter((project) => selectedProjectIds.includes(project._id))
            .map((project) => project?.client_name?._id)
            .filter(Boolean)
        ),
      ];
      setSelectedClients(selectedClientIds);

    } catch (error) {
      console.error("Error in handleCheckboxSprintChange:", error);
      // Optional: fallback to empty selections
      setSelectedSprints([]);
      setSelectedProjects([]);
      setSelectedClients([]);
    }
  };

  const handleSelectAllSprintChange = () => {
    try {
      const validSprints = Array.isArray(sortedSprints) ? sortedSprints : [];
      const validProjects = Array.isArray(sortedProjects) ? sortedProjects : [];

      if (!selectAllSprint) {
        const allSprintIds = validSprints.map((sprint) => sprint._id).filter(Boolean);
        setSelectedSprints(allSprintIds);

        const selectedProjectIds = [
          ...new Set(validSprints.map((sprint) => sprint?.project?._id).filter(Boolean)),
        ];
        setSelectedProjects(selectedProjectIds);

        const selectedClientIds = [
          ...new Set(
            validProjects
              .filter((project) => selectedProjectIds.includes(project._id))
              .map((project) => project?.client_name?._id)
              .filter(Boolean)
          ),
        ];
        setSelectedClients(selectedClientIds);
      } else {
        setSelectedSprints([]);
        setSelectedProjects([]);
        setSelectedClients([]);
      }

      setSelectAllSprint(!selectAllSprint);
    } catch (error) {
      console.error("Error in handleSelectAllSprintChange:", error);

      // Optionally reset state in case of failure
      setSelectedSprints([]);
      setSelectedProjects([]);
      setSelectedClients([]);
      setSelectAllSprint(false);
    }
  };

  useEffect(() => {
    if (isInitialLoad.current > 0) return;
    try {
      const validSelectedSprints = Array.isArray(selectedSprints) ? selectedSprints : [];
      const validSortedSprints = Array.isArray(sortedSprints) ? sortedSprints : [];

      const isAllSelected = validSelectedSprints.length === validSortedSprints.length;
      setSelectAllSprint(isAllSelected);

      if (isAllSelected) {
        selectSprint(null); // deselect all if all are selected
      } else {
        selectSprint(validSelectedSprints);
      }
    } catch (error) {
      console.error("Error in useEffect for sprint selection:", error);
      setSelectAllSprint(false);
      selectSprint([]); // fallback to deselection
    }
  }, [selectedSprints, sprints, sortedSprints]);


  const toggleSprintDropdown = () => {
    setIsSprintDropdownOpen(!isSprintDropdownOpen);
    setSprintSearchTerm('');
  };

  const toggleSprintModalDropdown = () => {
    if (sprintsLoading) return;
    setIsSprintModalDropdownOpen(!isSprintModalDropdownOpen);
    setSprintSearchTerm('');
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideTeamDropdown = teamDropdownRef.current && teamDropdownRef.current.contains(event.target);
    const isClickInsideUserStatusDropdown = userStatusDropdownRef.current && userStatusDropdownRef.current.contains(event.target);
    const isClickInsideTeamModalDropdown = teamModalDropdownRef.current && teamModalDropdownRef.current.contains(event.target);
    const isClickInsideUserStatusModaDropdown = userStatusModalDropdownRef.current && userStatusModalDropdownRef.current.contains(event.target);
    const isClickInsideProjectDropdown = projectDropdownRef.current && projectDropdownRef.current.contains(event.target);
    const isClickInsideProjectStatusDropdown = projectStatusDropdownRef.current && projectStatusDropdownRef.current.contains(event.target);
    const isClickInsideProjectModalDropdown = projectModalDropdownRef.current && projectModalDropdownRef.current.contains(event.target);
    const isClickInsideProjectStatusModaDropdown = projectStatusModalDropdownRef.current && projectStatusModalDropdownRef.current.contains(event.target);
    const isClickInsideClientDropdown = clientDropdownRef.current && clientDropdownRef.current.contains(event.target);
    const isClickInsideClientStatusDropdown = clientStatusDropdownRef.current && clientStatusDropdownRef.current.contains(event.target);
    const isClickInsideClientStatusList = clientStatusListRef.current && clientStatusListRef.current.contains(event.target);
    const isClickInsideClientStatusModaDropdown = clientStatusModalDropdownRef.current && clientStatusModalDropdownRef.current.contains(event.target);
    const isClickInsideClientModalDropdown = clientModalDropdownRef.current && clientModalDropdownRef.current.contains(event.target);
    const isClickInsideDeptDropdown = deptDropdownRef.current && deptDropdownRef.current.contains(event.target);
    const isClickInsideDeptModalDropdown = deptModalDropdownRef.current && deptModalDropdownRef.current.contains(event.target);
    const isClickInsideTagDropdown = tagDropdownRef.current && tagDropdownRef.current.contains(event.target);
    const isClickInsideTagModalDropdown = tagModalDropdownRef.current && tagModalDropdownRef.current.contains(event.target);
    const isClickInsideSprintDropdown = sprintDropdownRef.current && sprintDropdownRef.current.contains(event.target);
    const isClickInsideSprintModalDropdown = sprintModalDropdownRef.current && sprintModalDropdownRef.current.contains(event.target);
    const isClickInsideShowingDropdown = showingDropdownRef.current && showingDropdownRef.current.contains(event.target);
    const isClickInsideCalendarDropdown = calendarRef.current && calendarRef.current.contains(event.target);
    const isClickInsideModalCalendarDropdown =
      (calendarModalRef.current && calendarModalRef.current.contains(event.target)) ||
      (calendarModalPortalRef.current && calendarModalPortalRef.current.contains(event.target));

    if (!isClickInsideTeamDropdown) {
      setIsTeamDropdownOpen(false);
    }
    if (!isClickInsideUserStatusDropdown) {
      setIsUserStatusDropdownOpen(false);
    }
    if (!isClickInsideUserStatusModaDropdown) {
      setIsUserStatusModalDropdownOpen(false);
    }
    if (!isClickInsideTeamModalDropdown) {
      setIsTeamModalDropdownOpen(false);
    }
    if (!isClickInsideProjectDropdown) {
      setIsProjectDropdownOpen(false);
    }
    if (!isClickInsideProjectStatusDropdown) {
      setIsProjectStatusDropdownOpen(false);
    }
    if (!isClickInsideProjectStatusModaDropdown) {
      setIsProjectStatusModalDropdownOpen(false);
    }
    if (!isClickInsideProjectModalDropdown) {
      setIsProjectModalDropdownOpen(false);
    }
    if (!isClickInsideClientDropdown && !isClickInsideClientStatusList) {
      setIsClientDropdownOpen(false);
    }
    if (!isClickInsideClientStatusDropdown && !isClickInsideClientStatusList) {
      setIsClientStatusDropdownOpen(false);
    }
    if (!isClickInsideClientStatusModaDropdown) {
      setIsClientStatusModalDropdownOpen(false);
    }
    if (!isClickInsideClientModalDropdown) {
      setIsClientModalDropdownOpen(false);
    }
    if (!isClickInsideDeptDropdown) {
      setIsDeptDropdownOpen(false);
    }
    if (!isClickInsideDeptModalDropdown) {
      setIsDeptModalDropdownOpen(false);
    }
    if (!isClickInsideTagDropdown) {
      setIsTagDropdownOpen(false);
    }
    if (!isClickInsideTagModalDropdown) {
      setIsTagModalDropdownOpen(false);
    }
    if (!isClickInsideSprintDropdown) {
      setIsSprintDropdownOpen(false);
    }
    if (!isClickInsideSprintModalDropdown) {
      setIsSprintModalDropdownOpen(false);
    }
    if (!isClickInsideShowingDropdown) {
      setShowingDropdownOpen(false);
    }
    if (!isClickInsideCalendarDropdown) {
      setShowCalendar(false);
    }
    if (!isClickInsideModalCalendarDropdown) {
      setShowModalCalendar(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutsideDropdown);

    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, []);

  const queryClient = useQueryClient();

  const user = useSelector((state) => state.auth.user);

  const selectInitialTeam = () => {
    if (
      user &&
      user._id &&
      (user.userType === userTypeConsts.PROJECT_MANAGER ||
        user.userType === userTypeConsts.TEAM_MANAGER)
    ) {
      const projectManagerTeamId = user._id;
      selectTeam([projectManagerTeamId]);
    }
  };

  useEffect(() => {
    const projectsKey = projects?.map((p) => p._id).join(',') ?? '';
    const tagsKey = tags?.map((t) => t._id).join(',') ?? '';
    const sprintsKey = sprints?.map((s) => s._id).join(',') ?? '';
    const clientsKey = clients?.map((c) => c._id).join(',') ?? '';
    const departmentsKey = departments?.map((d) => d._id).join(',') ?? '';

    const projectsChanged = prevProjectsRef.current !== projectsKey;
    const tagsChanged = prevTagsRef.current !== tagsKey;
    const sprintsChanged = prevSprintsRef.current !== sprintsKey;
    const clientsChanged = prevClientsRef.current !== clientsKey;
    const departmentsChanged = prevDepartmentsRef.current !== departmentsKey;

    if (!projectsChanged && !tagsChanged && !sprintsChanged && !clientsChanged && !departmentsChanged && prevProjectsRef.current !== null) {
      return;
    }

    prevProjectsRef.current = projectsKey;
    prevTagsRef.current = tagsKey;
    prevSprintsRef.current = sprintsKey;
    prevClientsRef.current = clientsKey;
    prevDepartmentsRef.current = departmentsKey;
    
    const updateSelections = async () => {
      try {
        const filteredProjectIds = projects?.map((project) => project._id) || [];

        const initialClients = Array.isArray(clients)
          ? clients
            .filter((client) =>
              clientStatusFilter === "All"
                ? true
                : clientStatusFilter === "Active"
                  ? client.is_active === true
                  : client.is_active === false
            )
            .map((client) => client._id)
            .filter(Boolean)
          : [];
        const initialDepts = departments?.map((dept) => dept._id) || [];
        const initialTags = tags?.map((tag) => tag._id) || [];
        const initialSprints = sprints?.map((sprint) => sprint._id) || [];

        const allClientsSelected = initialClients.length === (Array.isArray(clients) ? clients.filter((c) => clientStatusFilter === "All" ? true : clientStatusFilter === "Active" ? c.is_active === true : c.is_active === false).length : 0);

        isInitialLoad.current += 1;

        setSelectedClients(initialClients);
        setSortedProjects(projects);
        setSelectedProjects(filteredProjectIds);
        setSelectedDepts(initialDepts);
        setSelectedTags(initialTags);
        setSelectedSprints(initialSprints);
        setSortedSprints(sprints);

        dispatch(setAllFilters({
          client: allClientsSelected ? null : initialClients,
          project: filteredProjectIds,
          department: null,
          tag: null,
          sprint: null,
        }));

        setTimeout(() => { isInitialLoad.current = Math.max(0, isInitialLoad.current - 1); }, 0);
      } catch (error) {
        console.error("Error during selections update:", error);
        isInitialLoad.current = Math.max(0, isInitialLoad.current - 1);
      }
    };

    updateSelections();
  }, [projects, tags, sprints, clients, departments, clientStatusFilter]);

  useEffect(() => {
    const userId = user?._id ?? '';
    const userChanged = prevUserRef.current !== userId;

    if (!userChanged && prevUserRef.current !== null) {
      return;
    }

    prevUserRef.current = userId;

    // Default to the current user immediately — don't wait on the teams list
    // (used only for the picker UI) to avoid a fetch-teams-then-fetch-timer-data waterfall.
    if (user && user._id) {
      isInitialLoad.current += 1;
      setSelectedTeams([user._id]);
      dispatch(setTeam([user._id]));
      setTimeout(() => { isInitialLoad.current = Math.max(0, isInitialLoad.current - 1); }, 0);
    }
  }, [user]);

  const selectTeam = async (team) => {
    await dispatch(setTeam(team));
  };
  const selectProject = async (project) => {
    await dispatch(setProject(project));
  };

  const selectDepartment = async (department) => {
    await dispatch(setDepartment(department));
  };

  const selectTag = async (tag) => {
    await dispatch(setTag(tag));
  };

  const selectSprint = async (sprint) => {
    await dispatch(setSprint(sprint));
  };

  const selectDate = (date) => {
    if (date) {
      setDates(new Date(date));
    } else {
      setDates(null);
    }
  };

  const onDateChange = (ranges) => {
    try {
      if (!ranges || !ranges.startDate || !ranges.endDate) {
        // fallback to current month if ranges is null or invalid
        const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        setDateRange([firstDayOfMonth, new Date()]);
      } else {
        const start = new Date(ranges.startDate);
        const end = new Date(ranges.endDate);

        // Validate parsed dates
        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
          throw new Error("Invalid date range provided.");
        }

        const startOfDayUTC = moment(start).startOf("day").toDate();
        const endOfDayUTC = moment(end).endOf("day").toDate();
        setDateRange([startOfDayUTC, endOfDayUTC]);
      }
    } catch (error) {
      console.error("Error in onDateChange:", error);

      // Fallback to current month
      const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      setDateRange([firstDayOfMonth, new Date()]);
    } finally {
      setShowCalendar(false);
      setShowModalCalendar(false);
    }
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const cancelCalendar = () => {
    setShowCalendar(false);
  };

  const toggleModalCalendar = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowModalCalendar((prev) => !prev);
  };

  const cancelModalCalendar = () => {
    setShowModalCalendar(false);
  };

  useEffect(() => {
    if (!showModalCalendar) {
      document.body.classList.remove("tt-calendar-open");
      return undefined;
    }
    document.body.classList.add("tt-calendar-open");
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const id = window.requestAnimationFrame(() => {
      const overlay = calendarModalPortalRef.current;
      if (overlay && overlay.parentNode === document.body) {
        document.body.appendChild(overlay);
      }
    });
    return () => {
      window.cancelAnimationFrame(id);
      document.body.classList.remove("tt-calendar-open");
      document.body.style.overflow = prevOverflow;
    };
  }, [showModalCalendar]);

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const toggleFilterModal = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(!showFilterModal);
  };

  const clearFilters = () => {
    try {
      setSelectedTeams([user?._id || ""]);
      setUserStatusFilter("Active");
      setProjectStatusFilter("All");
      setClientStatusFilter("Active");

      const defaultClientIds = Array.isArray(clients)
        ? clients
          .filter((client) => client.is_active === true)
          .map((client) => client._id)
          .filter(Boolean)
        : [];

      let filteredProjects = [];
      if (Array.isArray(projects)) {
        filteredProjects = projects.filter((project) => {
          const clientId = project?.client_name?._id;
          const isClientMatched = defaultClientIds.includes(clientId);
          // const isStatusMatch = project?.is_active === true;
          const isStatusMatch = true;
          return isClientMatched && isStatusMatch;
        });
      } else {
        console.warn("Projects list is not an array:", projects);
      }

      const filteredProjectIds = Array.isArray(filteredProjects)
        ? filteredProjects.map((project) => project._id).filter(Boolean)
        : [];

      let filteredSprints = [];
      if (Array.isArray(sprints)) {
        filteredSprints = sprints.filter((sprint) =>
          filteredProjectIds.includes(sprint?.project?._id)
        );
      } else {
        console.warn("Sprints list is not an array:", sprints);
      }

      setSelectedClients(defaultClientIds);
      setSelectedProjects(filteredProjectIds);
      setSortedProjects(filteredProjects);
      setSelectedDepts(Array.isArray(departments) ? departments.map((dept) => dept._id) : []);
      setSelectedTags(Array.isArray(tags) ? tags.map((tag) => tag._id) : []);
      setSelectedSprints(
        Array.isArray(filteredSprints)
          ? filteredSprints.map((sprint) => sprint._id).filter(Boolean)
          : []
      );
      setSortedSprints(filteredSprints);

      const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      setDateRange([firstDayOfMonth, new Date()]);
    } catch (error) {
      console.error("Error in clearFilters:", error);
    } finally {
      setShowConfirmationModal(false);
      setShowFilterModal(false);
    }
  };

  const checkAndShowConfirmationModal = () => {
    try {
      const defaultUserId = user?._id || "";
      const defaultClients = Array.isArray(clients)
        ? clients
          .filter((client) => client.is_active === true)
          .map((client) => client._id)
          .filter(Boolean)
        : [];
      const defaultProjects = Array.isArray(sortedProjects)
        ? sortedProjects
          .filter((project) => project.is_active === true)
          .map((project) => project._id)
          .filter(Boolean)
        : [];
      const defaultDepts = Array.isArray(departments) ? departments.map((dept) => dept._id) : [];
      const defaultTags = Array.isArray(tags) ? tags.map((tag) => tag._id) : [];
      const defaultSprints = Array.isArray(sortedSprints)
        ? sortedSprints.map((sprint) => sprint._id).filter(Boolean)
        : [];

      const isTeamsModified = !isEqual(selectedTeams, [defaultUserId]);
      const isClientsModified = !isEqual(selectedClients, defaultClients);
      const isProjectsModified = !isEqual(selectedProjects, defaultProjects);
      const isDeptsModified = !isEqual(selectedDepts, defaultDepts);
      const isTagsModified = !isEqual(selectedTags, defaultTags);
      const isSprintsModified = !isEqual(selectedSprints, defaultSprints);
      const isClientStatusModified = clientStatusFilter !== "Active";

      const currentStart = dateRange?.[0];
      const currentEnd = dateRange?.[1];
      const expectedStart = firstDayOfMonth;
      const expectedEnd = moment.tz(global?.config?.getTimeZone() || "UTC").toDate();

      const isDateRangeModified = !isEqual([currentStart, currentEnd], [expectedStart, expectedEnd]);

      if (
        isTeamsModified ||
        isClientsModified ||
        isProjectsModified ||
        isDeptsModified ||
        isTagsModified ||
        isSprintsModified ||
        isClientStatusModified ||
        isDateRangeModified
      ) {
        setShowConfirmationModal(true);
      } else {
        setShowFilterModal(false);
      }
    } catch (error) {
      console.error("Error checking filters for confirmation modal:", error);
      setShowFilterModal(false); // fallback close on error
    }
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
  };

  const handleApplyConfirm = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(false);
  };

  const disableInput = (event) => {
    event.preventDefault();
  };

  const groupAndSumDurations = (data) => {
    try {
      if (!Array.isArray(data)) {
        console.error("Expected an array for 'data', received:", data);
        return [];
      }

      const groupedData = [];
      let currentGroup = null;
      let totalDuration = 0;

      const formatDate = (entry) => (entry ? getEntryDayKey(entry) : null);

      data.forEach((row) => {
        // Safely extract required properties
        const rowUserId = row?.user?._id;
        const rowProjectId = row?.project?._id;
        const rowTask = row?.task;
        const rowDate = formatDate(row);

        if (rowUserId == null || rowProjectId == null || rowTask == null || rowDate == null) {
          console.warn("Skipping invalid row:", row);
          return;
        }

        const currentUserId = currentGroup?.user?._id;
        const currentProjectId = currentGroup?.project?._id;
        const currentTask = currentGroup?.task;
        const currentDate = formatDate(currentGroup);

        const isSameGroup =
          currentGroup &&
          currentUserId === rowUserId &&
          currentProjectId === rowProjectId &&
          currentTask === rowTask &&
          currentDate === rowDate;

        if (isSameGroup) {
          totalDuration += row.duration || 0;
          currentGroup.entries.push(row);
        } else {
          if (currentGroup) {
            currentGroup.totalDuration = totalDuration;
            groupedData.push(currentGroup);
          }

          currentGroup = {
            _id: row._id,
            user: row.user,
            task: row.task,
            project: row.project,
            sprint: row.sprint,
            tag: row.tag,
            date: row.date,
            localDate: row.localDate,
            localZone: row.localZone,
            startTime: row.startTime,
            endTime: row.endTime,
            totalDuration: row.duration || 0,
            entries: [row],
          };

          totalDuration = row.duration || 0;
        }
      });

      if (currentGroup) {
        currentGroup.totalDuration = totalDuration;
        groupedData.push(currentGroup);
      }

      return groupedData;
    } catch (error) {
      console.error("Error in groupAndSumDurations:", error);
      return [];
    }
  };

  const sortedTimerData = useMemo(() => [...timerDatas].sort((a, b) => {
    const aId = a?.project?._id ?? '';
    const bId = b?.project?._id ?? '';
    if (aId !== bId) return aId.localeCompare(bId);
    return 0;
  }), [timerDatas]);

  // Group and sum durations, then sort by date
  const updatedGroupedData = useMemo(() =>
    groupAndSumDurations(sortedTimerData).sort((a, b) => new Date(b.date) - new Date(a.date)),
    [sortedTimerData]
  );
  const totalResults = updatedGroupedData.length;
  const changeDurationFormat = (sec) => {
    let second = sec;
    const hours = Math.floor(second / 3600);
    const minutes = Math.floor((second % 3600) / 60);
    const seconds = second % 60;
    const formattedDuration = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    return formattedDuration;
  };

  const changeDurationHourFormat = (sec) => {
    const hours = sec / 3600;
    const formattedDuration = hours.toFixed(2);
    return formattedDuration;
  };

  const exportToExcel = () => {
    if (timerDatas.length === 0) {
      toast.error("No data to export.", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    setIsExporting(true);
    try {
      const now = new Date();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");
      const modifiedLog = timerDatas;

      const final = [];
      modifiedLog.map((item) => {
        final.push({
          User: item.user
            ? item.user.first_name
              ? `${item.user.first_name} ${item.user.middle_name ? item.user.middle_name : ""} ${item.user.last_name ?? ""}`
              : item.user.company_first_name
                ? `${item.user.company_first_name} ${item.user.company_last_name ?? ""}`
                : `${item.user.company_name ?? ""} (Company)`
            : "",
          Email: item.user?.email ?? "",
          Task: item.task ?? "",
          "Client Name": item.project?.client_name?.client_name ?? "",
          Project: item.project?.project_name ?? "",
          "Sprint": item?.sprint?.sprint_name ? item.sprint.sprint_name : "",
          "Tag": item?.tag?.tag_name ? item.tag.tag_name : "",
          "Start Time": item.startTime ? TimestampConverter(item.startTime, getEntryZone(item)) : "",
          "End Time": item.endTime ? TimestampConverter(item.endTime, getEntryZone(item)) : "",
          Duration: changeDurationHourFormat(item.duration),
          "Actual Hours": changeDurationFormat(item.duration),
          Date: formatEntryDay(item),
          Billable: item.project?.is_billable === true ? "Yes" : "No",
        });
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(final);
      const colWidths = [
        { wpx: 80 },
        { wpx: 120 },
        { wpx: 120 },
        { wpx: 100 },
        { wpx: 135 },
        { wpx: 80 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 60 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 60 },
      ];
      worksheet["!cols"] = colWidths;
      // Add alignment to center align the first row and increase font size
      const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
      for (let i = 0; i < colWidths.length; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        const style = worksheet[cell]?.s || {};
        style.alignment = style.alignment || {};
        style.alignment.horizontal = "center !important";
        style.alignment.vertical = "center !important";
        style.font = { size: 14, bold: true };
        worksheet[cell] = { ...worksheet[cell], s: style };
      }

      // Set border for active area and increase font size
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          const style = worksheet[cell]?.s || {};
          style.font = { size: 12 };
          worksheet[cell] = { ...worksheet[cell], s: style };
        }
      }
      global.config.activityLog(
        window.location.href,
        "Timer",
        "Timer Data exported to Excel"
      );
      const fileName = `TimeTracker_Report_${formattedDate}_${formattedTime}.xlsx`;
      worksheet["!autofilter"] = { ref: range };
      XLSX.utils.book_append_sheet(workbook, worksheet, "TimeTracker Report");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      global.config.activityLog(
        window.location.href,
        "Invoice",
        "Error occurred while exporting to Excel"
      );
      alert("Error occurred while exporting to Excel.");
    } finally {
      setIsExporting(false);
    }
  };
  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
    documentTitle: "time-tracker-data",
    onAfterPrint: () => {
      setShowPrintSection(false);
    },
  });

  const [showPrintSection, setShowPrintSection] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handlePrintButtonClick = () => {
    try {
      setShowPrintSection(true);

      if (!Array.isArray(timerDatas) || timerDatas.length === 0) {
        toast.error("No data to print.", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setShowPrintSection(false);
        return;
      }

      const htmlc = `<h1>TEST</h1>`; // (optional or placeholder)

      // Add a delay before initiating the print to ensure component is rendered
      setTimeout(() => {
        try {
          if (printComponentRef.current) {
            handlePrint();
          } else {
            console.error("Print component ref is not available");
            toast.error("Print component not ready. Please try again.", {
              position: "bottom-right",
              autoClose: 2000,
            });
            setShowPrintSection(false);
          }
        } catch (printError) {
          console.error("Error during printing:", printError);
          toast.error("Print failed. Please try again.", {
            position: "bottom-right",
            autoClose: 2000,
          });
          setShowPrintSection(false);
        }
        // Note: setShowPrintSection(false) is now handled by onAfterPrint callback
        // which fires even when user cancels the print dialog
      }, 500);
    } catch (error) {
      console.error("Error in handlePrintButtonClick:", error);
      setShowPrintSection(false);
      toast.error("Unexpected error. Please try again.", {
        position: "bottom-right",
        autoClose: 2000,
      });
    }
  };

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  const convertToTimeZoneDate = (date, timeZone) => {
    try {
      if (!date || !timeZone) {
        console.warn("Invalid input to convertToTimeZoneDate:", { date, timeZone });
        return null;
      }

      const converted = moment.tz(date, timeZone);

      if (!converted.isValid()) {
        console.error("Invalid date format in convertToTimeZoneDate:", date);
        return null;
      }

      return converted.toDate();
    } catch (error) {
      console.error("Error in convertToTimeZoneDate:", error);
      return null;
    }
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      transition={{ duration: 0.5 }}
    >
      <div className="overview-outer-time overview-outer-time-outer">
        <div className="overview-top">
          <div className="overview-top-inner">
            <div className="overview-top-left">
              {isExporting ? (
                <div style={{ height: "44px", padding: "0 15px", backgroundColor: "#e5e7eb", borderRadius: "6px", animation: "pulse 1.5s ease-in-out infinite", minWidth: "120px" }} />
              ) : (
                <a onClick={exportToExcel}>
                  <span className="icon-export"><DownloadIcon /></span>
                  Export Data
                </a>
              )}
              {showPrintSection ? (
                <div style={{ height: "44px", padding: "0 15px", backgroundColor: "#e5e7eb", borderRadius: "6px", animation: "pulse 1.5s ease-in-out infinite", minWidth: "100px" }} />
              ) : (
                <a onClick={handlePrintButtonClick}>
                  <span className="icon-print"><PrintIcon /></span>
                  Print
                </a>
              )}
            </div>
            <div className="overview-top-right">
              <div className="showing-count">
                <div className="filter-inner showing-result">
                  <label>Showing</label>
                  <div
                    ref={showingDropdownRef}
                    className="select-modal-mainM custom-dropdown-user-new-outer"
                  >
                    <div
                      className="selected-option custom-dropdown-user-new"
                      onClick={() => !timerLoading && setShowingDropdownOpen(!showingDropdownOpen)}
                      style={{ cursor: 'pointer' }}
                    >
                      {totalResults < 10 ? totalResults.toString() : perPage.toString()}
                    </div>
                    {showingDropdownOpen && !timerLoading && (
                      <div className="custom-dropdown-new">
                        <ul className="showing-options-list">
                          {totalResults >= 10 && (
                            <li
                              className={perPage === 10 ? "selected-item" : ""}
                              onClick={() => {
                                setPerPages(10);
                                setShowingDropdownOpen(false);
                              }}
                            >
                              10
                            </li>
                          )}
                          {totalResults >= 20 && (
                            <li
                              className={perPage === 20 ? "selected-item" : ""}
                              onClick={() => {
                                setPerPages(20);
                                setShowingDropdownOpen(false);
                              }}
                            >
                              20
                            </li>
                          )}
                          {totalResults >= 30 && (
                            <li
                              className={perPage === 30 ? "selected-item" : ""}
                              onClick={() => {
                                setPerPages(30);
                                setShowingDropdownOpen(false);
                              }}
                            >
                              30
                            </li>
                          )}
                          {totalResults >= 40 && (
                            <li
                              className={perPage === 40 ? "selected-item" : ""}
                              onClick={() => {
                                setPerPages(40);
                                setShowingDropdownOpen(false);
                              }}
                            >
                              40
                            </li>
                          )}
                          {totalResults <= 200 && totalResults >= 10 && (
                            <li
                              className={perPage === totalResults ? "selected-item" : ""}
                              onClick={() => {
                                setPerPages(totalResults);
                                setShowingDropdownOpen(false);
                              }}
                            >
                              ALL
                            </li>
                          )}
                          {totalResults > 200 && (
                            <li
                              className={perPage === 200 ? "selected-item" : ""}
                              onClick={() => {
                                setPerPages(200);
                                setShowingDropdownOpen(false);
                              }}
                            >
                              200
                            </li>
                          )}
                          {/* Add more conditions as needed */}
                          {totalResults < 10 ? (
                            <li
                              className={totalResults < 10 ? "selected-item" : ""}
                              onClick={() => {
                                setPerPages(totalResults);
                                setShowingDropdownOpen(false);
                              }}
                            >
                              {totalResults}
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    )}
                  </div>
                  <label>of {timerLoading ? '...' : `${updatedGroupedData.length}`} Results</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="overview-inner-section">
          <div className={`filter-sec-overview active`}>
            <div className="invoice-filter-inner">
              <div className="invoice-filter-inner-section no-flter-all">
                <div className="filter-inner invoice-id">
                  <label htmlFor="fname">Task Name</label>
                  <input
                    type="text"
                    id="taskname"
                    name="taskname"
                    placeholder="Task name..."
                    value={taskName}
                    onChange={handleTaskNameChange}
                  />
                </div>
                {user &&
                  (user.userType === userTypeConsts.SUPER_ADMIN ||
                    user.userType === userTypeConsts.ADMIN ||
                    user.userType === userTypeConsts.PROJECT_MANAGER
                    //  || user.userType === userTypeConsts.TEAM_MANAGER
                  ) && (
                    <div className="filter-inner invoice-id">
                      <label>Teams</label>
                      <div className="custom-dropdown1 new-active-inactive" ref={teamDropdownRef}>
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={teamLoading ? undefined : toggleTeamDropdown}
                            style={{ cursor: teamLoading ? 'default' : 'pointer' }}
                          >
                            {teamLoading ? (
                              <div className="selected-option1">{user?.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : user?.company_first_name ? `${user.company_first_name} ${user.company_last_name || ''}`.trim() : 'Teams'}</div>
                            ) : selectAllTeam ? (
                              <div className="selected-option1">All Teams</div>
                            ) : selectedTeams.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedTeams[0]}
                                >
                                  {selectedTeams.length === teams.filter((team) => userStatusFilter === "All" ? true : userStatusFilter === "Active" ? team.is_active === true : team.is_active === false).length ? (
                                    "All Teams"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          teams.find((item) => item._id === selectedTeams[0])?.first_name
                                            ? `${teams.find((item) => item._id === selectedTeams[0]).first_name} 
                                          ${teams.find((item) => item._id === selectedTeams[0]).middle_name ?
                                              teams.find((item) => item._id === selectedTeams[0]).middle_name
                                              : ""
                                            } ${teams.find(
                                              (item) => item._id === selectedTeams[0]
                                            ).last_name ? teams.find((item) => item._id === selectedTeams[0]).last_name : ""}`
                                            : teams.find((item) => item._id === selectedTeams[0])?.company_first_name
                                              ? `${teams.find((item) => item._id === selectedTeams[0]).company_first_name
                                              } ${teams.find((item) => item._id === selectedTeams[0]).company_last_name ? teams.find(
                                                (item) => item._id === selectedTeams[0]).company_last_name : ""}`
                                              : `${teams.find((item) => item._id === selectedTeams[0])?.company_name
                                              } (Company)`
                                        }
                                      />
                                      {selectedTeams.length > 1 &&
                                        selectedTeams.length !== teams.length && (
                                          <div className="selected-option-count">
                                            {selectedTeams.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isTeamDropdownOpen && (
                            <div className="dropdown-list1">
                              {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && (
                                <>
                                  <div className="user-status-dropdown">
                                    <div className="user-status-dropdown-label" htmlFor="userStatusFilter">Filter by Status</div>
                                    <div className="custom-dropdown-user" ref={userStatusDropdownRef}>
                                      <div className="showing-name" onClick={toggleUserStatusDropdown}>
                                        {userStatusFilter ? userStatusFilter : "Active"}
                                      </div>
                                    </div>
                                  </div>
                                  {isUserStatusDropdownOpen && (
                                    <ul className="status-list">
                                      <li
                                        onClick={() => handleUserStatusChange("All")}
                                        className={userStatusFilter === "All" ? "selected-item" : ""}
                                      >
                                        All
                                      </li>
                                      <li
                                        onClick={() => handleUserStatusChange("Active")}
                                        className={userStatusFilter === "Active" ? "selected-item" : ""}
                                      >
                                        Active
                                      </li>
                                      <li
                                        onClick={() => handleUserStatusChange("Inactive")}
                                        className={userStatusFilter === "Inactive" ? "selected-item" : ""}
                                      >
                                        Inactive
                                      </li>
                                    </ul>
                                  )}
                                </>
                              )}
                              <div className="top-search-tracker-for">
                                <input
                                  type="text"
                                  placeholder="Search teams"
                                  value={userSearchTerm}
                                  onChange={handleUserSearchChange}
                                  className="search-bar"
                                />
                              </div>
                              {filteredUsers.filter(team =>
                                userStatusFilter === "All" ? true :
                                  userStatusFilter === "Active" ? team.is_active === true :
                                    team.is_active === false
                              ).length > 0 ? (
                                <div className="tracker-who-list">
                                  {userSearchTerm === "" && (
                                    <label
                                      className="checkbox-label1"
                                      key="selectAll"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectAllTeam}
                                        onChange={handleSelectAllTeamChange}
                                      />
                                      All Teams
                                    </label>
                                  )}
                                  {filteredUsers && filteredUsers
                                    .filter((team) =>
                                      userStatusFilter === "All" ? true : userStatusFilter === "Active" ? team.is_active === true : team.is_active === false
                                    )
                                    .map((team) => (
                                      <label
                                        className="checkbox-label1"
                                        key={team._id}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedTeams.includes(team._id)}
                                          onChange={() =>
                                            handleCheckboxTeamChange(team._id)
                                          }
                                        />
                                        {team.first_name
                                          ? `${team.first_name} ${team.middle_name
                                            ? team.middle_name
                                            : ""
                                          } ${team.last_name}`
                                          : team.company_first_name
                                            ? `${team.company_first_name} ${team.company_last_name
                                              ? team.company_last_name
                                              : ""
                                            }`
                                            : `${team.company_name} (Company)`}
                                      </label>
                                    ))}
                                </div>
                              ) : (
                                <div className="no-results-found-text">No teams found</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                <div className="filter-inner client">
                  <label htmlFor="client">Client</label>
                  <div className="custom-dropdown1 new-active-inactive" ref={clientDropdownRef}>
                    <div className="drop-down-inner">
                      <div 
                        className="selected-options1" 
                        onClick={clientLoading ? undefined : toggleClientDropdown}
                        style={{ cursor: clientLoading ? 'default' : 'pointer' }}
                      >
                        {clientLoading ? (
                          <div className="selected-option1">All Clients</div>
                        ) : selectAllClient ? (
                          <div className="selected-option1">All Clients</div>
                        ) : selectedClients.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div className="selected-option1" key={selectedClients[0]}>
                              {selectedClients.length ===
                                clients.filter((client) =>
                                  clientStatusFilter === "All"
                                    ? true
                                    : clientStatusFilter === "Active"
                                      ? client.is_active === true
                                      : client.is_active === false
                                ).length ? (
                                "All Clients"
                              ) : (
                                <>
                                  <TruncateFilterFieldView
                                    textContent={
                                      clients.find((item) => item._id === selectedClients[0])
                                        ?.client_name
                                    }
                                  />
                                  {selectedClients.length > 1 &&
                                    selectedClients.length !==
                                    clients.filter((client) =>
                                      clientStatusFilter === "All"
                                        ? true
                                        : clientStatusFilter === "Active"
                                          ? client.is_active === true
                                          : client.is_active === false
                                    ).length && (
                                      <div className="selected-option-count">
                                        {selectedClients.length - 1}+
                                      </div>
                                    )}
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                      {isClientDropdownOpen && (
                        <div className="dropdown-list1">
                          {(user.userType === userTypeConsts.SUPER_ADMIN ||
                            user.userType === userTypeConsts.ADMIN) && (
                              <>
                                <div className="user-status-dropdown">
                                  <div
                                    className="user-status-dropdown-label"
                                    htmlFor="clientStatusFilter"
                                  >
                                    Filter by Status
                                  </div>
                                  <div
                                    className="custom-dropdown-user"
                                    ref={clientStatusDropdownRef}
                                  >
                                    <div
                                      className="showing-name"
                                      onClick={toggleClientStatusDropdown}
                                    >
                                      {clientStatusFilter ? clientStatusFilter : "Active"}
                                    </div>
                                  </div>
                                </div>
                                {isClientStatusDropdownOpen && (
                                  <ul className="status-list" ref={clientStatusListRef} onClick={(e) => e.stopPropagation()}>
                                    <li
                                      onClick={() => handleClientStatusChange("All")}
                                      className={clientStatusFilter === "All" ? "selected-item" : ""}
                                    >
                                      All
                                    </li>
                                    <li
                                      onClick={() => handleClientStatusChange("Active")}
                                      className={
                                        clientStatusFilter === "Active" ? "selected-item" : ""
                                      }
                                    >
                                      Active
                                    </li>
                                    <li
                                      onClick={() => handleClientStatusChange("Inactive")}
                                      className={
                                        clientStatusFilter === "Inactive" ? "selected-item" : ""
                                      }
                                    >
                                      Inactive
                                    </li>
                                  </ul>
                                )}
                              </>
                            )}
                          <div className="top-search-tracker-for">
                            <input
                              type="text"
                              placeholder="Search clients"
                              value={clientSearchTerm}
                              onChange={handleClientSearchChange}
                              className="search-bar"
                            />
                          </div>
                          {filteredClients.filter((client) =>
                            clientStatusFilter === "All"
                              ? true
                              : clientStatusFilter === "Active"
                                ? client.is_active === true
                                : client.is_active === false
                          ).length > 0 ? (
                            <div className="tracker-who-list">
                              {clientSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllClient}
                                    onChange={handleSelectAllClientChange}
                                  />
                                  All Clients
                                </label>
                              )}
                              {filteredClients
                                .filter((client) =>
                                  clientStatusFilter === "All"
                                    ? true
                                    : clientStatusFilter === "Active"
                                      ? client.is_active === true
                                      : client.is_active === false
                                )
                                .slice()
                                .sort((a, b) =>
                                  a.client_name
                                    ?.toLowerCase()
                                    .localeCompare(b.client_name?.toLowerCase())
                                )
                                .map((client) => (
                                  <label className="checkbox-label1" key={client._id}>
                                    <input
                                      type="checkbox"
                                      checked={selectedClients.includes(client._id)}
                                      onChange={() => handleCheckboxClientChange(client._id)}
                                    />
                                    {client.client_name && `${client.client_name}`}
                                  </label>
                                ))}
                            </div>
                          ) : (
                            <div className="no-results-found-text">No clients found</div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="filter-inner invoice-status">
                  <label>Project</label>
                  <div className="custom-dropdown1 new-active-inactive" ref={projectDropdownRef}>
                    <div className="drop-down-inner">
                      <div
                        className="selected-options1"
                        onClick={projectLoading ? undefined : toggleProjectDropdown}
                        style={{ cursor: projectLoading ? 'default' : 'pointer' }}
                      >
                        {projectLoading ? (
                          <div className="selected-option1">All Projects</div>
                        ) : selectAllProject ? (
                          <div className="selected-option1">All Projects</div>
                        ) : selectedProjects.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div className="selected-option1" key={selectedProjects[0]} >
                              {selectedProjects.length ===
                                sortedProjects.filter((project) =>
                                  projectStatusFilter === "All"
                                    ? true
                                    : projectStatusFilter === "Active"
                                      ? project.is_active === true && project.is_archived === false
                                      : projectStatusFilter === "Inactive"
                                        ? project.is_active === false && project.is_archived === false
                                        : project.is_archived === true
                                ).length ? (
                                "All Projects"
                              ) : (
                                <>
                                  <TruncateFilterFieldView
                                    textContent={
                                      sortedProjects.find(
                                        (item) => item._id === selectedProjects[0]
                                      )?.project_name
                                    }
                                  />
                                  {selectedProjects.length > 1 &&
                                    selectedProjects.length !==
                                    sortedProjects.filter((project) =>
                                      projectStatusFilter === "All"
                                        ? true
                                        : projectStatusFilter === "Active"
                                          ? project.is_active === true && project.is_archived === false
                                          : projectStatusFilter === "Inactive"
                                            ? project.is_active === false && project.is_archived === false
                                            : project.is_archived === true
                                    ).length && (
                                      <div className="selected-option-count">
                                        {selectedProjects.length - 1}+
                                      </div>
                                    )}
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                      {isProjectDropdownOpen && (
                        <div className="dropdown-list1">
                          {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && (
                            <>
                              <div className="user-status-dropdown">
                                <div className="user-status-dropdown-label" htmlFor="projectStatusFilter">Filter by Status</div>
                                <div className="custom-dropdown-user" ref={projectStatusDropdownRef}>
                                  <div className="showing-name" onClick={toggleProjectStatusDropdown}>
                                    {projectStatusFilter ? projectStatusFilter : "All"}
                                  </div>
                                </div>
                              </div>
                              {isProjectStatusDropdownOpen && (
                                <ul className="status-list">
                                  <li
                                    onClick={() => handleProjectStatusChange("All")}
                                    className={projectStatusFilter === "All" ? "selected-item" : ""}
                                  >
                                    All
                                  </li>
                                  <li
                                    onClick={() => handleProjectStatusChange("Active")}
                                    className={projectStatusFilter === "Active" ? "selected-item" : ""}
                                  >
                                    Active
                                  </li>
                                  <li
                                    onClick={() => handleProjectStatusChange("Inactive")}
                                    className={projectStatusFilter === "Inactive" ? "selected-item" : ""}
                                  >
                                    Inactive
                                  </li>
                                  <li
                                    onClick={() => handleProjectStatusChange("Archived")}
                                    className={projectStatusFilter === "Archived" ? "selected-item" : ""}
                                  >
                                    Archived
                                  </li>
                                </ul>
                              )}
                            </>
                          )}
                          <div className="top-search-tracker-for">
                            <input
                              type="text"
                              placeholder="Search projects"
                              value={projectSearchTerm}
                              onChange={handleProjectSearchChange}
                              className="search-bar"
                            />
                          </div>
                          {filteredDropdownProjects
                            .filter((project) =>
                              projectStatusFilter === "All"
                                ? true
                                : projectStatusFilter === "Active"
                                  ? project.is_active === true && project.is_archived === false
                                  : projectStatusFilter === "Inactive"
                                    ? project.is_active === false && project.is_archived === false
                                    : project.is_archived === true
                            ).length > 0 ? (
                            <div className="tracker-who-list">
                              {projectSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllProject}
                                    onChange={handleSelectAllProjectChange}
                                  />
                                  All Projects
                                </label>
                              )}
                              <div className="map-outer">
                                {filteredDropdownProjects
                                  .filter((project) =>
                                    projectStatusFilter === "All"
                                      ? true
                                      : projectStatusFilter === "Active"
                                        ? project.is_active === true && project.is_archived === false
                                        : projectStatusFilter === "Inactive"
                                          ? project.is_active === false && project.is_archived === false
                                          : project.is_archived === true
                                  )
                                  .slice()
                                  .sort((a, b) =>
                                    a.project_name
                                      ?.toLowerCase()
                                      .localeCompare(b.project_name?.toLowerCase())
                                  )
                                  .map((project) => (
                                    <label
                                      className="checkbox-label1"
                                      key={project._id}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectedProjects.includes(project._id)}
                                        onChange={() =>
                                          handleCheckboxProjectChange(project._id)
                                        }
                                      />
                                      {project.project_name && `${project.project_name}`}
                                    </label>
                                  ))}
                              </div>
                            </div>
                          ) : (
                            <div className="no-results-found-text">No projects found</div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {user &&
                  (user.userType === userTypeConsts.SUPER_ADMIN ||
                    user.userType === userTypeConsts.ADMIN ||
                    user.userType === userTypeConsts.PROJECT_MANAGER ||
                    user.userType === userTypeConsts.TEAM_MANAGER) && (
                    <div className="filter-inner payment-status">
                      <label htmlFor="paymentStatus">Department</label>
                      <div className="custom-dropdown1" ref={deptDropdownRef}>
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={departmentLoading ? undefined : toggleDeptDropdown}
                            style={{ cursor: departmentLoading ? 'default' : 'pointer' }}
                          >
                            {departmentLoading ? (
                              <div className="selected-option1">All Departments</div>
                            ) : selectAllDept ? (
                              <div className="selected-option1">All Departments</div>
                            ) : selectAllDept ? (
                              <div className="selected-option1">All Departments</div>
                            ) : selectedDepts.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedDepts[0]}
                                >
                                  {selectedDepts.length === departments.length ? (
                                    "All Departments"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          departments.find(
                                            (item) =>
                                              item._id === selectedDepts[0]
                                          )?.user_department
                                        }
                                      />
                                      {selectedDepts.length > 1 &&
                                        selectedDepts.length !==
                                        departments.length && (
                                          <div className="selected-option-count">
                                            {selectedDepts.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isDeptDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search departments"
                                value={deptSearchTerm}
                                onChange={handleDeptSearchChange}
                                className="search-bar"
                              />
                              {filteredDepts.length > 0 ? (
                                <>
                                  {deptSearchTerm === "" && (
                                    <label
                                      className="checkbox-label1"
                                      key="selectAll"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectAllDept}
                                        onChange={handleSelectAllDeptChange}
                                      />
                                      All Departments
                                    </label>
                                  )}
                                  {filteredDepts
                                    .slice()
                                    .sort((a, b) =>
                                      a.user_department
                                        ?.toLowerCase()
                                        .localeCompare(
                                          b.user_department?.toLowerCase()
                                        )
                                    )
                                    .map((dept) => (
                                      <label
                                        className="checkbox-label1"
                                        key={dept._id}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedDepts.includes(
                                            dept._id
                                          )}
                                          onChange={() =>
                                            handleCheckboxDeptChange(dept._id)
                                          }
                                        />
                                        {dept.user_department &&
                                          `${dept.user_department}`}
                                      </label>
                                    ))}
                                </>
                              ) : (
                                <div>No departments found</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                <div className="filter-inner invoice-type">
                  <label htmlFor="invoice-type">Tag</label>
                  <div className="custom-dropdown1" ref={tagDropdownRef}>
                    <div className="drop-down-inner">
                      <div
                        className="selected-options1"
                        onClick={tagsLoading ? undefined : toggleTagDropdown}
                        style={{ cursor: tagsLoading ? 'default' : 'pointer' }}
                      >
                        {tagsLoading ? (
                          <div className="selected-option1">All Tags</div>
                        ) : selectAllTag ? (
                          <div className="selected-option1">All Tags</div>
                        ) : selectedTags.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div
                              className="selected-option1"
                              key={selectedTags[0]}
                            >
                              {selectedTags.length === tags.length ? (
                                "All Tags"
                              ) : (
                                <>
                                  <TruncateFilterFieldView
                                    textContent={
                                      tags.find(
                                        (item) => item._id === selectedTags[0]
                                      )?.tag_name
                                    }
                                  />
                                  {selectedTags.length > 1 &&
                                    selectedTags.length !== tags.length && (
                                      <div className="selected-option-count">
                                        {selectedTags.length - 1}+
                                      </div>
                                    )}
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                      {isTagDropdownOpen && (
                        <div className="dropdown-list1">
                          <input
                            type="text"
                            placeholder="Search tags"
                            value={tagSearchTerm}
                            onChange={handleTagSearchChange}
                            className="search-bar"
                          />
                          {filteredTags.length > 0 ? (
                            <>
                              {tagSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllTag}
                                    onChange={handleSelectAllTagChange}
                                  />
                                  All Tags
                                </label>
                              )}
                              {filteredTags
                                .slice()
                                .sort((a, b) =>
                                  a.tag_name
                                    ?.toLowerCase()
                                    .localeCompare(b.tag_name?.toLowerCase())
                                )
                                .map((tag) => (
                                  <label
                                    className="checkbox-label1"
                                    key={tag._id}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedTags.includes(tag._id)}
                                      onChange={() =>
                                        handleCheckboxTagChange(tag._id)
                                      }
                                    />
                                    {tag.tag_name && `${tag.tag_name}`}
                                  </label>
                                ))}
                            </>
                          ) : (
                            <div>No tags found</div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="filter-inner invoice-type">
                  <label htmlFor="invoice-type">Sprint</label>
                  <div className="custom-dropdown1" ref={sprintDropdownRef}>
                    <div className="drop-down-inner">
                      <div
                        className="selected-options1"
                        onClick={sprintsLoading ? undefined : toggleSprintDropdown}
                        style={{ cursor: sprintsLoading ? 'default' : 'pointer' }}
                      >
                        {sprintsLoading ? (
                          <div className="selected-option1">All Sprints</div>
                        ) : selectAllSprint ? (
                          <div className="selected-option1">All Sprints</div>
                        ) : selectedSprints.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div
                              className="selected-option1"
                              key={selectedSprints[0]}
                            >
                              {selectedSprints.length === sortedSprints.length ? (
                                "All Sprints"
                              ) : (
                                <>
                                  <TruncateFilterFieldView
                                    textContent={
                                      sortedSprints.find(
                                        (item) => item._id === selectedSprints[0]
                                      )?.sprint_name
                                    }
                                  />
                                  {selectedSprints.length > 1 &&
                                    selectedSprints.length !== sortedSprints.length && (
                                      <div className="selected-option-count">
                                        {selectedSprints.length - 1}+
                                      </div>
                                    )}
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                      {isSprintDropdownOpen && (
                        <div className="dropdown-list1">
                          <input
                            type="text"
                            placeholder="Search sprints"
                            value={sprintSearchTerm}
                            onChange={handleSprintSearchChange}
                            className="search-bar"
                          />
                          {filteredSprints.length > 0 ? (
                            <>
                              {sprintSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllSprint}
                                    onChange={handleSelectAllSprintChange}
                                  />
                                  All Sprints
                                </label>
                              )}
                              {filteredSprints
                                .slice()
                                .sort((a, b) =>
                                  a.sprint_name
                                    ?.toLowerCase()
                                    .localeCompare(b.sprint_name?.toLowerCase())
                                )
                                .map((sprint) => (
                                  <label
                                    className="checkbox-label1"
                                    key={sprint._id}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedSprints.includes(sprint._id)}
                                      onChange={() =>
                                        handleCheckboxSprintChange(sprint._id)
                                      }
                                    />
                                    {sprint.sprint_name && `${sprint.sprint_name}`}
                                  </label>
                                ))}
                            </>
                          ) : (
                            <div>No sprints found</div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="filter-inner due-date">
                  <label htmlFor="dueDate" className="calendar-icon">
                    Date Range
                  </label>
                  <div
                    className="date-picker-outer date-picker-outer-all"
                    ref={calendarRef}
                  >
                    <div className="custom-picker-icon custom-picker-icon-all">
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 14 14"
                        fill="currentColor"
                        aria-hidden="true"
                        focusable="false"
                        className="rs-picker-toggle-caret rs-icon"
                        aria-label="calendar"
                        data-category="legacy"
                      >
                        <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                      </svg>
                    </div>
                    <div className="custoom-icon-calender custoom-icon-calender-all">
                      <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range ">

                        <input
                          type="text"
                          value={
                            dateRange
                              ? `${new Date(dateRange[0]).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                }
                              )} to ${new Date(dateRange[1]).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                }
                              )}`
                              : null
                          }
                          id="invoiceId"
                          name="invoiceId"
                          placeholder="All Time"
                          onClick={toggleCalendar}
                          autoComplete="off"
                          readOnly
                        />
                      </div>
                      <div className="date-range-new right-align">
                        {showCalendar && (
                          <Calendar
                            onCancel={cancelCalendar}
                            onChange={(range) => {
                              const sDate = new Date(range.startDate.getFullYear(), range.startDate.getMonth(), range.startDate.getDate());
                              const eDate = new Date(range.endDate.getFullYear(), range.endDate.getMonth(), range.endDate.getDate());
                              // Convert the selected date range to the desired timezone
                              const adjustedStartDate = range.startDate ? new Date(range.startDate) : null;
                              const adjustedEndDate = range.endDate ? new Date(range.endDate) : null;
                              onDateChange({
                                startDate: adjustedStartDate,
                                endDate: adjustedEndDate,
                              });
                            }}
                            initialRange={{
                              startDate: dateRange ? new Date(dateRange[0]) : null,
                              endDate: dateRange ? new Date(dateRange[1]) : null,
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-invoice-right apply-fliter-right">
                <button onClick={toggleFilterModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="17"
                    viewBox="0 0 13 17"
                    fill="none"
                  >
                    <path
                      d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z"
                      fill="#6479F8"
                    />
                    <path
                      d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z"
                      fill="#6479F8"
                    />
                    <path
                      d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z"
                      fill="#6479F8"
                    />
                  </svg>
                  All Filters
                </button>
              </div>
              <Modal
                isOpen={showFilterModal}
                onRequestClose={checkAndShowConfirmationModal}
                contentLabel="Filter Modal"
                className="new-filter-modal"
                overlayClassName="tt-overview-filter-overlay"
                closeTimeoutMS={480}
                style={{
                  content: {
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                    padding: "20px",
                  },
                  overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99999,
                  },
                }}
              >
                <div className="new-nodal-invoice-outer-sec">
                  <div className="new-modal-top-sec">
                    <div className="new-modal-heading">All filters</div>
                    <a
                      className="close-image-clr1"
                      onClick={checkAndShowConfirmationModal}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path d="M1 13L13 1" stroke="black" />
                        <path d="M1 0.999999L13 13" stroke="black" />
                      </svg>{" "}
                    </a>
                  </div>
                  <div className="invoice-filter-inner-section">
                    <div className="filter-inner invoice-id">
                      <label htmlFor="fname">Task Name</label>
                      <input type="text" id="taskname" name="taskname" placeholder="Task name..." value={taskName} onChange={handleTaskNameChange} />
                    </div>
                    {user &&
                      (user.userType === userTypeConsts.SUPER_ADMIN ||
                        user.userType === userTypeConsts.ADMIN ||
                        user.userType === userTypeConsts.PROJECT_MANAGER ||
                        user.userType === userTypeConsts.TEAM_MANAGER) && (
                        <div className="filter-inner invoice-id">
                          <label>Team</label>
                          <div
                            className="custom-dropdown1"
                            ref={teamModalDropdownRef}
                          >
                            <div className="drop-down-inner">
                              <div
                                className="selected-options1"
                                onClick={teamLoading ? undefined : toggleTeamModalDropdown}
                                style={{ cursor: teamLoading ? 'default' : 'pointer' }}
                              >
                                {teamLoading ? (
                                  <div className="selected-option1">{user?.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : user?.company_first_name ? `${user.company_first_name} ${user.company_last_name || ''}`.trim() : 'Teams'}</div>
                                ) : selectAllTeam ? (
                                  <div className="selected-option1">All Teams</div>
                                ) : selectedTeams.length === 0 ? (
                                  <div className="placeholder">Select</div>
                                ) : (
                                  <>
                                    <div
                                      className="selected-option1"
                                      key={selectedTeams[0]}
                                    >
                                      {selectedTeams.length === teams.filter((team) => userStatusFilter === "All" ? true : userStatusFilter === "Active" ? team.is_active === true : team.is_active === false).length ? (
                                        "All Teams"
                                      ) : (
                                        <>
                                          <TruncateFilterFieldView
                                            textContent={
                                              teams.find((item) => item._id === selectedTeams[0])?.first_name
                                                ? `${teams.find((item) => item._id === selectedTeams[0]).first_name
                                                } ${teams.find((item) => item._id === selectedTeams[0]).middle_name
                                                  ? teams.find((item) => item._id === selectedTeams[0]).middle_name
                                                  : ""
                                                } ${teams.find((item) => item._id === selectedTeams[0]).last_name ? teams.find((item) => item._id === selectedTeams[0]).last_name : ""}`
                                                : teams.find(
                                                  (item) => item._id === selectedTeams[0])?.company_first_name
                                                  ? `${teams.find(
                                                    (item) => item._id === selectedTeams[0]).company_first_name} 
                                                  ${teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                                    ? teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                                    : ""
                                                  }`
                                                  : `${teams.find((item) => item._id === selectedTeams[0])?.company_name
                                                  } (Company)`
                                            }
                                          />
                                          {selectedTeams.length > 1 &&
                                            selectedTeams.length !==
                                            teams.length && (
                                              <div className="selected-option-count">
                                                {selectedTeams.length - 1}+
                                              </div>
                                            )}
                                        </>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                              {isTeamModalDropdownOpen && (
                                <div className="dropdown-list1">
                                  {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && (
                                    <>
                                      <div className="user-status-dropdown">
                                        <div htmlFor="userStatusFilter">Filter by Status</div>
                                        <div className="custom-dropdown-user" ref={userStatusModalDropdownRef}>
                                          <div className="showing-name" onClick={toggleUserStatusModalDropdown}>
                                            {userStatusFilter ? userStatusFilter : "Active"}
                                          </div>
                                        </div>
                                      </div>
                                      {isUserStatusModalDropdownOpen && (
                                        <ul className="status-list">
                                          <li
                                            onClick={() => handleUserStatusChange("All")}
                                            className={userStatusFilter === "All" ? "selected-item" : ""}
                                          >
                                            All
                                          </li>
                                          <li
                                            onClick={() => handleUserStatusChange("Active")}
                                            className={userStatusFilter === "Active" ? "selected-item" : ""}
                                          >
                                            Active
                                          </li>
                                          <li
                                            onClick={() => handleUserStatusChange("Inactive")}
                                            className={userStatusFilter === "Inactive" ? "selected-item" : ""}
                                          >
                                            Inactive
                                          </li>
                                        </ul>
                                      )}
                                    </>
                                  )}
                                  <input
                                    type="text"
                                    placeholder="Search teams"
                                    value={userSearchTerm}
                                    onChange={handleUserSearchChange}
                                    className="search-bar"
                                  />
                                  {filteredUsers.filter(team =>
                                    userStatusFilter === "All" ? true :
                                      userStatusFilter === "Active" ? team.is_active === true :
                                        team.is_active === false
                                  ).length > 0 ? (
                                    <>
                                      {userSearchTerm === "" && (
                                        <label className="checkbox-label1" key="selectAll">
                                          <input
                                            type="checkbox"
                                            checked={selectAllTeam}
                                            onChange={handleSelectAllTeamChange}
                                          />
                                          All Teams
                                        </label>
                                      )}
                                      {filteredUsers && filteredUsers
                                        .filter((team) =>
                                          userStatusFilter === "All" ? true : userStatusFilter === "Active" ? team.is_active === true : team.is_active === false
                                        )
                                        .map((team) => (
                                          <label
                                            className="checkbox-label1"
                                            key={team._id}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={selectedTeams.includes(
                                                team._id
                                              )}
                                              onChange={() =>
                                                handleCheckboxTeamChange(team._id)
                                              }
                                            />
                                            {team.first_name
                                              ? `${team.first_name} ${team.middle_name
                                                ? team.middle_name
                                                : ""
                                              } ${team.last_name}`
                                              : team.company_first_name
                                                ? `${team.company_first_name} ${team.company_last_name
                                                  ? team.company_last_name
                                                  : ""
                                                }`
                                                : `${team.company_name} (Company)`}
                                          </label>
                                        ))}
                                    </>
                                  ) : (
                                    <div className="no-results-found-text">No teams found</div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="filter-inner client">
                      <label htmlFor="client">Client</label>
                      <div className="custom-dropdown1" ref={clientModalDropdownRef} >
                        <div className="drop-down-inner">
                          <div className="selected-options1" onClick={toggleClientModalDropdown} >
                            {selectAllClient ? (
                              <div className="selected-option1">All Clients</div>
                            ) : selectedClients.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div className="selected-option1" key={selectedClients[0]} >
                                  {selectedClients.length ===
                                    clients.filter((client) =>
                                      clientStatusFilter === "All"
                                        ? true
                                        : clientStatusFilter === "Active"
                                          ? client.is_active === true
                                          : client.is_active === false
                                    ).length ? (
                                    "All Clients"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          clients.find((item) => item._id === selectedClients[0])
                                            ?.client_name
                                        }
                                      />
                                      {selectedClients.length > 1 &&
                                        selectedClients.length !==
                                        clients.filter((client) =>
                                          clientStatusFilter === "All"
                                            ? true
                                            : clientStatusFilter === "Active"
                                              ? client.is_active === true
                                              : client.is_active === false
                                        ).length && (
                                          <div className="selected-option-count">
                                            {selectedClients.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isClientModalDropdownOpen && (
                            <div className="dropdown-list1">
                              {(user.userType === userTypeConsts.SUPER_ADMIN ||
                                user.userType === userTypeConsts.ADMIN) && (
                                  <>
                                    <div className="user-status-dropdown">
                                      <div htmlFor="clientStatusFilter">Filter by Status</div>
                                      <div className="custom-dropdown-user" ref={clientStatusModalDropdownRef}>
                                        <div className="showing-name" onClick={toggleClientStatusModalDropdown}>
                                          {clientStatusFilter ? clientStatusFilter : "Active"}
                                        </div>
                                      </div>
                                    </div>
                                    {isClientStatusModalDropdownOpen && (
                                      <ul className="status-list">
                                        <li
                                          onClick={() => handleClientStatusChange("All")}
                                          className={clientStatusFilter === "All" ? "selected-item" : ""}
                                        >
                                          All
                                        </li>
                                        <li
                                          onClick={() => handleClientStatusChange("Active")}
                                          className={
                                            clientStatusFilter === "Active" ? "selected-item" : ""
                                          }
                                        >
                                          Active
                                        </li>
                                        <li
                                          onClick={() => handleClientStatusChange("Inactive")}
                                          className={
                                            clientStatusFilter === "Inactive" ? "selected-item" : ""
                                          }
                                        >
                                          Inactive
                                        </li>
                                      </ul>
                                    )}
                                  </>
                                )}
                              <input
                                type="text"
                                placeholder="Search clients"
                                value={clientSearchTerm}
                                onChange={handleClientSearchChange}
                                className="search-bar"
                              />
                              {filteredClients.filter((client) =>
                                clientStatusFilter === "All"
                                  ? true
                                  : clientStatusFilter === "Active"
                                    ? client.is_active === true
                                    : client.is_active === false
                              ).length > 0 ? (
                                <>
                                  {clientSearchTerm === "" && (
                                    <label className="checkbox-label1" key="selectAll" >
                                      <input
                                        type="checkbox"
                                        checked={selectAllClient}
                                        onChange={handleSelectAllClientChange}
                                      />
                                      All Clients
                                    </label>
                                  )}
                                  {filteredClients
                                    .filter((client) =>
                                      clientStatusFilter === "All"
                                        ? true
                                        : clientStatusFilter === "Active"
                                          ? client.is_active === true
                                          : client.is_active === false
                                    )
                                    .slice()
                                    .sort((a, b) =>
                                      a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
                                    )
                                    .map((client) => (
                                      <label className="checkbox-label1" key={client._id} >
                                        <input
                                          type="checkbox"
                                          checked={selectedClients.includes(client._id)}
                                          onChange={() =>
                                            handleCheckboxClientChange(client._id)
                                          }
                                        />
                                        {client.client_name && `${client.client_name}`}
                                      </label>
                                    ))}
                                </>
                              ) : (
                                <div className="no-results-found-text">No clients found</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner invoice-status">
                      <label>Project</label>
                      <div
                        className="custom-dropdown1"
                        ref={projectModalDropdownRef}
                      >
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={projectLoading ? undefined : toggleProjectModalDropdown}
                            style={{ cursor: projectLoading ? 'default' : 'pointer' }}
                          >
                            {projectLoading ? (
                              <div className="selected-option1">All Projects</div>
                            ) : selectAllProject ? (
                              <div className="selected-option1">All Projects</div>
                            ) : selectedProjects.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedProjects[0]}
                                >
                                  {selectedProjects.length ===
                                    sortedProjects.filter((project) =>
                                      projectStatusFilter === "All"
                                        ? true
                                        : projectStatusFilter === "Active"
                                          ? project.is_active === true && project.is_archived === false
                                          : projectStatusFilter === "Inactive"
                                            ? project.is_active === false && project.is_archived === false
                                            : project.is_archived === true
                                    ).length ? (
                                    "All Projects"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          sortedProjects.find(
                                            (item) =>
                                              item._id === selectedProjects[0]
                                          )?.project_name
                                        }
                                      />
                                      {selectedProjects.length > 1 &&
                                        selectedProjects.length !==
                                        sortedProjects.filter((project) =>
                                          projectStatusFilter === "All"
                                            ? true
                                            : projectStatusFilter === "Active"
                                              ? project.is_active === true && project.is_archived === false
                                              : projectStatusFilter === "Inactive"
                                                ? project.is_active === false && project.is_archived === false
                                                : project.is_archived === true
                                        ).length && (
                                          <div className="selected-option-count">
                                            {selectedProjects.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isProjectModalDropdownOpen && (
                            <div className="dropdown-list1">
                              {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && (
                                <>
                                  <div className="user-status-dropdown">
                                    <div htmlFor="projectStatusFilter">Filter by Status</div>
                                    <div className="custom-dropdown-user" ref={projectStatusModalDropdownRef}>
                                      <div className="showing-name" onClick={toggleProjectStatusModalDropdown}>
                                        {projectStatusFilter ? projectStatusFilter : "Active"}
                                      </div>
                                    </div>
                                  </div>
                                  {isProjectStatusModalDropdownOpen && (
                                    <ul className="status-list">
                                      <li
                                        onClick={() => handleProjectStatusChange("All")}
                                        className={projectStatusFilter === "All" ? "selected-item" : ""}
                                      >
                                        All
                                      </li>
                                      <li
                                        onClick={() => handleProjectStatusChange("Active")}
                                        className={projectStatusFilter === "Active" ? "selected-item" : ""}
                                      >
                                        Active
                                      </li>
                                      <li
                                        onClick={() => handleProjectStatusChange("Inactive")}
                                        className={projectStatusFilter === "Inactive" ? "selected-item" : ""}
                                      >
                                        Inactive
                                      </li>
                                      <li
                                        onClick={() => handleProjectStatusChange("Archived")}
                                        className={projectStatusFilter === "Archived" ? "selected-item" : ""}
                                      >
                                        Archived
                                      </li>
                                    </ul>
                                  )}
                                </>
                              )}
                              <input
                                type="text"
                                placeholder="Search projects"
                                value={projectSearchTerm}
                                onChange={handleProjectSearchChange}
                                className="search-bar"
                              />
                              {filteredDropdownProjects.filter(project =>
                                projectStatusFilter === "All"
                                  ? true
                                  : projectStatusFilter === "Active"
                                    ? project.is_active === true && project.is_archived === false
                                    : projectStatusFilter === "Inactive"
                                      ? project.is_active === false && project.is_archived === false
                                      : project.is_archived === true
                              ).length > 0 ? (
                                <>
                                  {projectSearchTerm === "" && (
                                    <label className="checkbox-label1" key="selectAll" >
                                      <input
                                        type="checkbox"
                                        checked={selectAllProject}
                                        onChange={handleSelectAllProjectChange}
                                      />
                                      All Projects
                                    </label>
                                  )}
                                  {filteredDropdownProjects
                                    .filter(project =>
                                      projectStatusFilter === "All"
                                        ? true
                                        : projectStatusFilter === "Active"
                                          ? project.is_active === true && project.is_archived === false
                                          : projectStatusFilter === "Inactive"
                                            ? project.is_active === false && project.is_archived === false
                                            : project.is_archived === true
                                    )
                                    .slice()
                                    .sort((a, b) =>
                                      a.project_name?.toLowerCase()
                                        .localeCompare(
                                          b.project_name?.toLowerCase()
                                        )
                                    )
                                    .map((project) => (
                                      <label className="checkbox-label1" key={project._id} >
                                        <input
                                          type="checkbox"
                                          checked={selectedProjects.includes(
                                            project._id
                                          )}
                                          onChange={() =>
                                            handleCheckboxProjectChange(
                                              project._id
                                            )
                                          }
                                        />
                                        {project.project_name &&
                                          `${project.project_name}`}
                                      </label>
                                    ))}
                                </>
                              ) : (
                                <div className="no-results-found-text">No projects found</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner payment-status">
                      <label htmlFor="paymentStatus">Department</label>
                      <div
                        className="custom-dropdown1"
                        ref={deptModalDropdownRef}
                      >
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={departmentLoading ? undefined : toggleDeptModalDropdown}
                            style={{ cursor: departmentLoading ? 'default' : 'pointer' }}
                          >
                            {departmentLoading ? (
                              <div className="selected-option1">All Departments</div>
                            ) : selectedDepts.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedDepts[0]}
                                >
                                  {selectedDepts.length === departments.length ? (
                                    "All Departments"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          departments.find(
                                            (item) =>
                                              item._id === selectedDepts[0]
                                          )?.user_department
                                        }
                                      />
                                      {selectedDepts.length > 1 &&
                                        selectedDepts.length !==
                                        departments.length && (
                                          <div className="selected-option-count">
                                            {selectedDepts.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isDeptModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search departments"
                                value={deptSearchTerm}
                                onChange={handleDeptSearchChange}
                                className="search-bar"
                              />
                              {filteredDepts.length > 0 ? (
                                <>
                                  {deptSearchTerm === "" && (
                                    <label
                                      className="checkbox-label1"
                                      key="selectAll"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectAllDept}
                                        onChange={handleSelectAllDeptChange}
                                      />
                                      All Departments
                                    </label>
                                  )}
                                  {filteredDepts
                                    .slice()
                                    .sort((a, b) =>
                                      a.user_department
                                        ?.toLowerCase()
                                        .localeCompare(
                                          b.user_department?.toLowerCase()
                                        )
                                    )
                                    .map((dept) => (
                                      <label
                                        className="checkbox-label1"
                                        key={dept._id}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedDepts.includes(
                                            dept._id
                                          )}
                                          onChange={() =>
                                            handleCheckboxDeptChange(dept._id)
                                          }
                                        />
                                        {dept.user_department &&
                                          `${dept.user_department}`}
                                      </label>
                                    ))}
                                </>
                              ) : (
                                <div className="no-results-found-text">No depatments found</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner invoice-id">
                      <label htmlFor="invoice-type">Tag</label>
                      <div className="custom-dropdown1" ref={tagModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={tagsLoading ? undefined : toggleTagModalDropdown}
                            style={{ cursor: tagsLoading ? 'default' : 'pointer' }}
                          >
                            {tagsLoading ? (
                              <div className="selected-option1">All Tags</div>
                            ) : selectAllTag ? (
                              <div className="selected-option1">All Tags</div>
                            ) : selectedTags.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedTags[0]}
                                >
                                  {selectedTags.length === tags.length ? (
                                    "All Tags"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          tags.find(
                                            (item) => item._id === selectedTags[0]
                                          )?.tag_name
                                        }
                                      />
                                      {selectedTags.length > 1 &&
                                        selectedTags.length !== tags.length && (
                                          <div className="selected-option-count">
                                            {selectedTags.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isTagModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search tags"
                                value={tagSearchTerm}
                                onChange={handleTagSearchChange}
                                className="search-bar"
                              />
                              {filteredTags.length > 0 ? (
                                <>
                                  {tagSearchTerm === "" && (
                                    <label
                                      className="checkbox-label1"
                                      key="selectAll"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectAllTag}
                                        onChange={handleSelectAllTagChange}
                                      />
                                      All Tags
                                    </label>
                                  )}
                                  {filteredTags
                                    .slice()
                                    .sort((a, b) =>
                                      a.tag_name
                                        ?.toLowerCase()
                                        .localeCompare(b.tag_name?.toLowerCase())
                                    )
                                    .map((tag) => (
                                      <label
                                        className="checkbox-label1"
                                        key={tag._id}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedTags.includes(tag._id)}
                                          onChange={() =>
                                            handleCheckboxTagChange(tag._id)
                                          }
                                        />
                                        {tag.tag_name && `${tag.tag_name}`}
                                      </label>
                                    ))}
                                </>
                              ) : (
                                <div className="no-results-found-text">No tags found</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner invoice-type">
                      <label htmlFor="invoice-type">Sprint</label>
                      <div className="custom-dropdown1" ref={sprintModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div
                            className="selected-options1"
                            onClick={sprintsLoading ? undefined : toggleSprintModalDropdown}
                            style={{ cursor: sprintsLoading ? 'default' : 'pointer' }}
                          >
                            {sprintsLoading ? (
                              <div className="selected-option1">All Sprints</div>
                            ) : selectAllSprint ? (
                              <div className="selected-option1">All Sprints</div>
                            ) : selectedSprints.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div
                                  className="selected-option1"
                                  key={selectedSprints[0]}
                                >
                                  {selectedSprints.length === sortedSprints.length ? (
                                    "All Sprints"
                                  ) : (
                                    <>
                                      <TruncateFilterFieldView
                                        textContent={
                                          sortedSprints.find(
                                            (item) => item._id === selectedSprints[0]
                                          )?.sprint_name
                                        }
                                      />
                                      {selectedSprints.length > 1 &&
                                        selectedSprints.length !== sortedSprints.length && (
                                          <div className="selected-option-count">
                                            {selectedSprints.length - 1}+
                                          </div>
                                        )}
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          {isSprintModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search sprints"
                                value={sprintSearchTerm}
                                onChange={handleSprintSearchChange}
                                className="search-bar"
                              />
                              {filteredSprints.length > 0 ? (
                                <>
                                  {sprintSearchTerm === "" && (
                                    <label
                                      className="checkbox-label1"
                                      key="selectAll"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectAllSprint}
                                        onChange={handleSelectAllSprintChange}
                                      />
                                      All Sprints
                                    </label>
                                  )}
                                  {filteredSprints
                                    .slice()
                                    .sort((a, b) =>
                                      a.sprint_name
                                        ?.toLowerCase()
                                        .localeCompare(b.sprint_name?.toLowerCase())
                                    )
                                    .map((sprint) => (
                                      <label
                                        className="checkbox-label1"
                                        key={sprint._id}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedSprints.includes(sprint._id)}
                                          onChange={() =>
                                            handleCheckboxSprintChange(sprint._id)
                                          }
                                        />
                                        {sprint.sprint_name && `${sprint.sprint_name}`}
                                      </label>
                                    ))}
                                </>
                              ) : (
                                <div className="no-results-found-text">No sprints found</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner due-date">
                      <label htmlFor="dueDate" className="calendar-icon">
                        Date Range
                      </label>
                      <div
                        className="date-picker-outer date-picker-outer-all"
                        ref={calendarModalRef}
                      >
                        <div
                          className="custom-picker-icon custom-picker-icon-all"
                          onClick={toggleModalCalendar}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") toggleModalCalendar(e);
                          }}
                          aria-label="Open date range calendar"
                        >
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 14 14"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            className="rs-picker-toggle-caret rs-icon"
                            aria-label="calendar"
                            data-category="legacy"
                          >
                            <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                          </svg>
                        </div>

                        <div className="custoom-icon-calender custoom-icon-calender-all">
                          <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range">

                            <input
                              type="text"
                              // onChange={}
                              value={
                                dateRange
                                  ? `${new Date(dateRange[0]).toLocaleDateString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    }
                                  )} to ${new Date(
                                    dateRange[1]
                                  ).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}`
                                  : null
                              }
                              id="invoiceId"
                              name="invoiceId"
                              placeholder="All Time"
                              onClick={toggleModalCalendar}
                              onMouseDown={(e) => e.stopPropagation()}
                              autoComplete="off"
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="filter-buttons">
                  <button className="clear-all" onClick={clearFilters}>
                    Clear All
                  </button>
                  <button className="apply-filter" onClick={applyFilters}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="17"
                      viewBox="0 0 13 17"
                      fill="none"
                    >
                      <path
                        d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z"
                        fill="white"
                      />
                      <path
                        d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z"
                        fill="white"
                      />
                      <path
                        d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z"
                        fill="white"
                      />
                    </svg>
                    Apply Filters
                  </button>
                </div>
              </Modal>

              {/* Must be outside the filters modal so it stacks above the filters overlay */}
              <Modal
                className="delete-modal tt-discard-filter-modal"
                overlayClassName="tt-discard-filter-overlay"
                isOpen={showConfirmationModal}
                onRequestClose={handleCancel}
                contentLabel="Confirm filter changes"
                closeTimeoutMS={480}
              >
                <div className="delete-modal-content">
                  <h2>Apply or Discard changes?</h2>
                  <p>Do you want to Apply or Discard filter changes?</p>

                  <div className="delete-modal-buttons">
                    <button onClick={handleApplyConfirm}>
                      Apply Changes
                    </button>
                    <button className="buttons-rejected" onClick={clearFilters}>Discard Changes</button>
                  </div>
                </div>
              </Modal>

              {/* Calendar portal rendered outside filter modal so it always stacks above ReactModal */}
              {showModalCalendar && ReactDOM.createPortal(
                <div
                  ref={calendarModalPortalRef}
                  className="time-tracker-calendar-portal-overlay"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => { if (e.target === e.currentTarget) cancelModalCalendar(); }}
                >
                  <div
                    className="date-range-new date-range-portal"
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Calendar
                      onCancel={cancelModalCalendar}
                      onChange={(range) => {
                        const adjustedStartDate = range.startDate ? new Date(range.startDate) : null;
                        const adjustedEndDate = range.endDate ? new Date(range.endDate) : null;
                        onDateChange({ startDate: adjustedStartDate, endDate: adjustedEndDate });
                      }}
                      initialRange={{
                        startDate: dateRange ? new Date(dateRange[0]) : null,
                        endDate: dateRange ? new Date(dateRange[1]) : null,
                      }}
                    />
                  </div>
                </div>,
                document.body
              )}
            </div>
          </div>
        </div>

        <div className="overview-outer-sec-time">
          <div className="total-sec-overview">
            <OverviewTotal TotalHours={timerDatas} isLoading={timerLoading} />
          </div>
          <div className="graph-piechart">
            <div className="overview-graph-time">
              <TimeTrackerOverviewGraph
                timerData={timerDatas}
                graphDate={dateRange[1]}
                team={tracker.team}
              />
            </div>
            <div className="piechart">
              <TrackerOverviewPieChart timerData={timerDatas} isLoading={timerLoading} />
            </div>
          </div>
          <div className="time-table-section">
            <TimeTable
              timerData={timerDatas}
              perPage={perPage}
              graphDate={dateRange}
              user={user}
              isLoading={timerLoading}
              queryClient={queryClient}
            />
          </div>
          <div className="print-sec-invoice" style={{ display: "none" }}>
            <div ref={printComponentRef}>
              {showPrintSection && (
                <TimeTrackerOverviewPrintTable
                  timerData={timerDatas}
                  graphDate={dateRange}
                  user={user}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TimeTrackerOverview;
